import { useState, useEffect, ReactNode, useMemo, useRef } from "react";
import { Stepper, Step, StepLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GoogleMapReact from "google-map-react";
import CloseIcon from "@mui/icons-material/Close";
import JoditEditor from "jodit-react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  TextField,
  Typography,
  FormControl,
  Radio,
  RadioGroup,
  Card,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Switch,
  Container,
  Autocomplete,
  TableHead,
  Modal,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import {
  useFindParkingSpaceLocationByIdMutation,
  useSaveParkingSpaceLocationMutation,
  useUpdateParkingSpaceLocationMutation,
} from "../../../store/api/parkingsApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAllServiceProviderDetailMutation } from "../../../store/api/serviceProviderApi";
import {
  useDeleteParkingSpaceLocationImageMutation,
  useFindByParkingLocationIdMutation,
  useUploadParkingSpaceLocationImageMutation,
} from "../../../store/api/parkingSpaceApi";
import { useGetEnumDataMutation } from "../../../store/api/enumApi";
import { getSpecificEnumData, setEnumData } from "../../../store/state/enumSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useSaveMutation, useUpdateMutation } from "../../../store/api/parkingTimeApi";
import { formatDateTime, formatTimeHHMM, GET_DAYS, getUTCTime, getISTTime, getUniqueKey } from "../parkingspaces/utility";
import LocationSearchInput from "./PlaceLocationAutoComplete";
import { useGetParkingTypeDataMutation } from "../../../store/api/parkingTypeApi";
import AllParkingsListHead from "../bookings/AllParkingsListHead";
import SearchNotFound from "../../../components/SearchNotFound";
import { useGetBlackoutDatesMutation, useSaveBlackoutDateMutation, useUpdateBlackoutDateMutation } from "../../../store/api/blackoutDayApi";
import { getBlackoutDay, setBlackoutDay } from "../../../store/state/blackoutDaySlice";
import { format } from "date-fns";
import toast from "react-hot-toast";
import { getAuthDetails } from "../../../store/state/authSlice";
import Loading from "../../../components/Loading";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  useGetParkingCategoryByIdMutation,
  useGetParkingCategoryDetailMutation,
  useSaveParkingCategoryDetailMutation,
  useUpdateParkingCategoryDetailMutation,
} from "../../../store/api/parkingCategoryApi";
import { useGetCategoryListMutation, useGetSubCategoryListMutation } from "../../../store/api/vehicleCategoryApi";
import Iconify from "../../../components/Iconify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EditorToolbar, { modules, formats } from "../../../components/EditorToolbar";
import { useSaveVehicleDetailsMutation, useUpdateVehicleDetailsMutation } from "../../../store/api/vehicleDetailsApi";

const useStyles = makeStyles((theme) => ({
  button: {
    marginRight: theme.spacing(1),
  },
}));

function getSteps() {
  return ["Location", "Contact ", "Overview", "Photo", "Prices", "BlackoutDate", "Amentities", "Instructions"];
}
const getIcon = (name: any) => <Iconify icon={name} width={22} height={22} sx={undefined} />;

const TABLE_HEAD = [
  { id: " date", label: "Date", alignRight: false },
  { id: "description", label: "Event", alignRight: false },
];

const blackoutDateSchema = Yup.object().shape({
  description: Yup.string().required("This field is required").typeError("Please enter description"),
  date: Yup.string().required("This field is required").typeError("Please enter date and time"),
});

// const bookingTypes = [
//   {
//     value: "Night",
//     id: 1,
//   },
//   {
//     value: "Day",
//     id: 2,
//   },
//   {
//     value: "Overnight",
//     id: 3,
//   },
// ];

const VehicleForm = () => {
  const dispatch: any = useAppDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [skippedSteps, setSkippedSteps] = useState([]) as any;
  const steps = getSteps();
  const [address, setAddress]: any = useState({});
  const token = JSON.parse(localStorage.getItem("login") || "{}").token;
  const [updateParkingSpaceLocation, updateResponse] = useUpdateParkingSpaceLocationMutation();
  const { state }: any = useLocation();
  console.log(state, "state");
  const [flag, setFlag] = useState(false);
  const [condition, setCondition] = useState(false);
  const [saveParkingSpaceLocation, saveResponse] = useSaveParkingSpaceLocationMutation();
  const [saveVehicleDetails, saveVehicleDetailsResponse] = useSaveVehicleDetailsMutation();
  const [updateVehicleDetails, updateVehicleDetailsResponse] = useUpdateVehicleDetailsMutation();
  const [selectedParkingLocationId, setSelectedParkingLocationId] = useState(null);
  const [selectedVehicleDetailsId, setSelectedVehicleDetailsId] = useState(null);
  const [serviceProviders, setServiceProviders] = useState<any>([]);
  console.log(serviceProviders, "serviceProviders");
  const [getAllServiceProviderDetail, serviceProviderResponse] = useGetAllServiceProviderDetailMutation();
  const [filterName, setFilterName] = useState("");
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [uploadParkingSpaceLocationImage, ParkingSpaceLocationImageResponse] = useUploadParkingSpaceLocationImageMutation();
  const [save, saveTimeResponse] = useSaveMutation();
  const [findByParkingLocationId, findByParkingLocationIdResponse] = useFindByParkingLocationIdMutation();
  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedPermitImage, setUploadedPermitImage] = useState([]);
  const [isImgUrl, setIsImgUrl] = useState(false);
  const [isPermitImageUploaded, setIsPermitImageUploaded] = useState(false);
  const [cityImage, setCityImage] = useState<null | any>();
  const [permitImage, setPermitImage] = useState<null | any>();
  const [getEnumData, enumResponse] = useGetEnumDataMutation();
  const [marchantType, setMarchantType] = useState([]);
  const [bookingTypeEnum, setBookingTypeEnum] = useState([]);
  const [permitTypeEnum, setPermitTypeEnum] = useState([]);
  const [carTypeEnum, setCarTypeEnum] = useState([]);
  const [fuelTypeEnum, setFuelTypeEnum] = useState([]);
  const [gearTypeEnum, setGearTypeEnum] = useState([]);
  let enumData: any = useAppSelector(getSpecificEnumData);
  const [parkingCategory, setParkingCategory] = useState("");
  const [findParkingSpaceLocationById, findParkingSpaceLocationByIdResponse] = useFindParkingSpaceLocationByIdMutation();
  const [updateState, setUpdateState] = useState({});
  const [tierType, setTierType] = useState([]);
  const [getParkingTypeData, getParkingTypeDataResponse] = useGetParkingTypeDataMutation();
  const [parkingManagementData, setParkingManagementData] = useState([]);
  const [orderBy, setOrderBy] = useState("id");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selected, setSelected] = useState([]);
  const [blackoutData, setBlackoutData] = useState([]);
  const [saveBlackoutDate, saveBlackoutDateResponse] = useSaveBlackoutDateMutation();
  const [getBlackoutDates, getBlackoutDatesResponse] = useGetBlackoutDatesMutation();
  const [updateBlackoutDate, updateBlackoutDateResponse] = useUpdateBlackoutDateMutation();
  const getBlackoutData = useAppSelector(getBlackoutDay);
  const authDetail = useAppSelector(getAuthDetails);
  const authData = JSON.parse(localStorage.getItem("login") || "{}");
  const [blackoutDateId, setBlackoutDateId] = useState();
  const [deleteParkingSpaceLocationImage, deleteParkingSpaceLocationImageResponse] = useDeleteParkingSpaceLocationImageMutation();
  const [selectedOptions, setSelectedOptions] = useState() as any;
  const [serviceProviderName, setServiceProviderName] = useState("");
  const [saveParkingCategoryDetail, saveParkingCategoryDetailResponse] = useSaveParkingCategoryDetailMutation();
  const [updateParkingCategoryDetail, updateParkingCategoryDetailResponse] = useUpdateParkingCategoryDetailMutation();
  const [getParkingCategoryDetail, getParkingCategoryDetailResponse] = useGetParkingCategoryDetailMutation();
  const [getCategoryList, getCategoryListResponse] = useGetCategoryListMutation();
  const [getSubCategoryList, getSubCategoryListResponse] = useGetSubCategoryListMutation();
  let [operationHoursList, SetOperationHoursList] = useState(
    Array(7).fill({ fromTime: null, toTime: null, operationalStatus: "", dayOfWeek: "", dayId: 0 })
  ) as any;
  const editor = useRef(null);

  const [blackoutForm, setBlackoutForm] = useState({
    description: "",
    date: "",
  });
  const [isPinRequired, setIsPinRequired] = useState(false);

  const [formValues, setFormValues] = useState({
    chassisNumber: "",
    color: "",
    engineNumber: "",
    insuranceExpiryDate: new Date(),
    vehicleExpiryDate: new Date(),
    make: "",
    manufacturer: "",
    mileage: "",
    model: "",
    registrationNumber: "",
    seatingCapacity: "",
    luggageCapacity: "",
    type: "",
    year: "",
    fuelType: "",
    gearType: "",
    isAc: "",
    address: "",
    latitude: "",
    longitude: "",
    stateName: "",
    countryName: "",
    cityName: "",
    Apartment: "",
    serviceProviderId: "0",
    Email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    GSTno: "",
    PANno: "",
    NameOfParentCompany: "",
    // isPinRequired: "",
    // parkingPin: "",
    // ListingDescription: "",
    // ListingInstruction: "",
    // ListingName: "",
    CancellationPolicy: "",
    Specialinstructionsforemailconfirmation: "",
    inclusions: "",
    exclusions: "",
    // DailyPrices: "0",
    // HourlyLimit: "0",
    cancellationFee: "0",
    // NumberOfSlotavailable: "20",
    // minimumBookingHours: "2",
    amenities: [],
    // operationHoursList: Array(7).fill({ fromTime: null, toTime: null, operationalStatus: "", dayOfWeek: "", dayId: 0 }),
    // dailyLimit: "20",
    // hourlyRate: "0",
    cancellationDueTime: "0",
    // tierType: '',
    parkingTypeId: [],
    status: false,
    // parkingCategory: "0",
    CGST: "0",
    SGST: "0",
    IGST: "0",
    // fixedFee: "0",
    // fromTimeString: "",
    // toTimeString: "",
    // bookingType: "",
    // bookingUnits: "",
    commExtraRate: "0",
    commRate: "0",
    permitType: '',
    permitNumber: '',
    isFastag: '',
    isVerified: '',
  });

  // const [content, setContent] = useState(formValues.ListingDescription);
  // const [contentOne, setContentOne] = useState(formValues.ListingInstruction);
  const [contentTwo, setContentTwo] = useState(formValues.CancellationPolicy);
  const [contentThree, setContentThree] = useState(formValues.Specialinstructionsforemailconfirmation);
  const [contentFour, setContentFour] = useState(formValues.inclusions);
  const [contentFive, setContentFive] = useState(formValues.exclusions);
  const [rowdata, setRowData] = useState([]);
  const [parkingSlotCapacity, setParkingSlotCapacity] = useState(0);

  const config: any = {
    toolbarAdaptive: false,
  };

  useEffect(() => {
    getParkingCategoryDetail({
      token: token,
      payload: {
        status: true,
        parkingSpaceLocationId: state.editMode ? state.id : state.isApprove ? state.id : selectedParkingLocationId,
      },
    });
  }, [getParkingCategoryDetail]);

  useEffect(() => {
    if (getParkingCategoryDetailResponse.isSuccess) {
      setRowData(getParkingCategoryDetailResponse.data);
      const slotCapacity = getParkingCategoryDetailResponse?.data?.reduce((result: number, item: any) => {
        return result + item.capacity;
      }, 0);
      setParkingSlotCapacity(slotCapacity);
    }
    if (getParkingCategoryDetailResponse.isError) {
      toast.error("Something went wrong ");
    }
  }, [getParkingCategoryDetailResponse.isSuccess, getParkingCategoryDetailResponse.isError]);

  const getParkingTypeDataAsync = async (rowPerPages: any, pages: number, orders: string, typeNames = "") => {
    await getParkingTypeData({
      token: token,
      payload: {
        offset: rowPerPages,
        pageNumber: pages,
        sortOrder: orders,
        typeName: typeNames,
      },
    });
  };

  useEffect(() => {
    if (token) {
      getParkingTypeDataAsync(2000, 0, order);
    }
  }, []);

  useEffect(() => {
    if (getParkingTypeDataResponse.isSuccess) {
      const parkingType = getParkingTypeDataResponse.data.data.filter((item: any) => {
        return item.status == true;
      });
      setParkingManagementData(parkingType);
    }
  }, [getParkingTypeDataResponse.isSuccess]);

  useEffect(() => {
    getEnumData({ token: token });
  }, []);

  useEffect(() => {
    if (enumResponse.isSuccess) {
      dispatch(setEnumData(enumResponse.data));
    }
  }, [enumResponse.isSuccess]);

  useEffect(() => {
    if (enumData) {
      // setMarchantType(enumData['AMENITIES_TYPE']);
      setMarchantType(enumData["VEHICLE_AMENITIES_TYPE"]);
      setTierType(enumData["TIER_TYPE"]);
      setParkingCategory(enumData["PARKING_CATEGORY"]);
      setBookingTypeEnum(enumData["BOOKING_TYPE"]);
      setPermitTypeEnum(enumData["PERMIT_TYPE"]);
      setCarTypeEnum(enumData["VEHICLE_TYPE"]);
      setFuelTypeEnum(enumData["VEHICLE_FUEL_TYPE"]);
      setGearTypeEnum(enumData["VEHICLE_GEAR_TYPE"]);
    }
  }, [enumData]);

  const uploadImages = (docType: string, img: string) => {
    const formData = new FormData();
    formData.append("file", img);
    uploadParkingSpaceLocationImage({
      payload: formData,
      parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
      token: token,
      docType: docType,
    });
  };

  useEffect(() => {
    if (cityImage) {
      uploadImages("parking", cityImage);
    }
  }, [cityImage]);

  useEffect(() => {
    if (permitImage) {
      uploadImages("permit", permitImage);
    }
  }, [permitImage]);


  useEffect(() => {
    if (ParkingSpaceLocationImageResponse.isSuccess) {
      setFlag(true);
      findByParkingLocationId({
        parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
        token: token,
      });
    }
  }, [ParkingSpaceLocationImageResponse.isSuccess]);

  // useEffect(() => {
  //   if (findByParkingLocationIdResponse.isSuccess) {
  //     console.log("findByParkingLocationIdResponse.data", findByParkingLocationIdResponse.data)
  //     setUploadedImage(findByParkingLocationIdResponse.data);
  //     if (findByParkingLocationIdResponse.data?.some((d: any) => d?.documentType == "permit")) {
  //       setIsPermitImageUploaded(true);
  //     } else {
  //       setIsPermitImageUploaded(false);
  //     }
  //     setCondition(true);
  //   }
  // }, [ParkingSpaceLocationImageResponse.isSuccess, uploadImages]);

  useEffect(() => {
    if (findByParkingLocationIdResponse.isSuccess) {
      console.log("findByParkingLocationIdResponse.data", findByParkingLocationIdResponse.data);

      const permitImages: any = findByParkingLocationIdResponse?.data?.filter((d: any) => d?.documentType === "permit");
      console.log(permitImages, "permitImages");

      const parkingImages: any = findByParkingLocationIdResponse?.data?.filter((d: any) => d?.documentType === "parking");
      console.log(parkingImages, "parkingImages");

      // Prevent unnecessary state updates to avoid re-renders
      setUploadedPermitImage((prev) => JSON.stringify(prev) !== JSON.stringify(permitImages) ? permitImages : prev);
      setUploadedImage((prev) => JSON.stringify(prev) !== JSON.stringify(parkingImages) ? parkingImages : prev);

      const isPermitUploaded = findByParkingLocationIdResponse.data?.some((d: any) => d?.documentType === "permit");
      setIsPermitImageUploaded((prev) => prev !== isPermitUploaded ? isPermitUploaded : prev);

      setCondition((prev) => prev !== true ? true : prev);
    }
  }, [findByParkingLocationIdResponse.isSuccess, uploadImages]);


  const saveParkingDataToServer = async (values: any) => {
    console.log("saveParkingDataToServer values:", values);
    await saveParkingSpaceLocation({
      payload: getPayload(activeStep, values),
      token: token,
    });
  };

  useEffect(() => {
    if (saveResponse.isSuccess) {
      setActiveStep(activeStep + 1);
      setSelectedParkingLocationId(saveResponse.data.id);
    } else if (saveResponse.error) {
      let errorData: any = saveResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error("Technical issue, please try again!!!");
      }
    }
  }, [saveResponse.isSuccess, saveResponse.error]);

  const saveVehicleDetailsToServer = async (values: any) => {
    if (state.editMode || state.isApprove) {
      await updateVehicleDetails({
        payload: getPayload("saveVehicle", values),
        token: token,
      });
    } else {
      await saveVehicleDetails({
        payload: getPayload("saveVehicle", values),
        token: token,
      });
    }

  };

  useEffect(() => {
    if (saveVehicleDetailsResponse.isSuccess) {
      setSelectedVehicleDetailsId(saveVehicleDetailsResponse.data.id);
      UpdateParkingDataToServer(saveVehicleDetailsResponse.data.id);
    } else if (saveVehicleDetailsResponse.error) {
      let errorData: any = saveVehicleDetailsResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error("Technical issue, please try again!!!");
      }
    }
  }, [saveVehicleDetailsResponse.isSuccess, saveVehicleDetailsResponse.error]);

  useEffect(() => {
    if (updateVehicleDetailsResponse.isSuccess) {
      setSelectedVehicleDetailsId(updateVehicleDetailsResponse.data.id);
      UpdateParkingDataToServer(updateVehicleDetailsResponse.data.id);
    } else if (updateVehicleDetailsResponse.error) {
      let errorData: any = updateVehicleDetailsResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;

      if (msg) {
        toast.error(msg);
      } else {
        toast.error("Technical issue, please try again!!!");
      }
    }
  }, [updateVehicleDetailsResponse.isSuccess, updateVehicleDetailsResponse.error]);

  const UpdateParkingDataToServer = async (values: any) => {
    await updateParkingSpaceLocation({
      payload: getPayload(activeStep, values),
      token: token,
    });
  };

  useEffect(() => {
    if (updateResponse.isSuccess) {
      if (activeStep === 7) {
        navigate(state.isAdmin == false ? '/dashboard/vehicle-overview' : '/dashboard/all-vehicle-spaces');
      } else {
        setActiveStep(activeStep + 1)
      }
    }
    if (updateResponse.error) {
      let errorData: any = updateResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      if (msg) {
        toast.error(msg);
      } else {
        toast.error("Technical issue, please try again!!!");
      }
    }
  }, [updateResponse.isSuccess, updateResponse.isError]);

  const SaveTimeToServer = async (values: any) => {
    await save({
      payload: getPayload(activeStep, values),
      token: token,
    });
  };

  function getPayload(step: any, values: any) {
    switch (step) {
      case 0:
        return {
          address: address.formatted_address,
          apartmentNo: values.Apartment,
          flag: "Location",
          latitude: address?.lat,
          longitude: address?.lng,
          stateName: address.state,
          countryName: address.country,
          cityName: address.city,
          serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
          id: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
          isConform: state.isApprove,
          isEdit: state.editMode,
        };
      case 1:
        return {
          flag: "Contact",
          contactEmail: values.Email,
          contactFirstName: values.firstName,
          contactLastName: values.lastName,
          phoneNumber: values.phoneNumber,
          parentCompanyDba: values.GSTno,
          parentCompanyEin: values.PANno,
          parentCompanyName: values.NameOfParentCompany,
          serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
          isEdit: state.editMode,
          id: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
          isConform: state.isApprove,
        };

      case 2:
        return {
          flag: "vehicle",
          vehicleId: values ? values : selectedVehicleDetailsId,
          id: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
        };
      // return {
      //   flag: 'Overview',
      //   listingDescription: values.ListingDescription,
      //   listingInstruction: values.ListingInstruction,
      //   isPinRequired: values.isPinRequired !== null ? values.isPinRequired : false,
      //   parkingPin: isPinRequired === true ? values.parkingPin : null,
      //   listingName: values.ListingName,
      // cancellationPolicy: values.CancellationPolicy,
      //   specialInstructions: values.Specialinstructionsforemailconfirmation,
      //   serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
      //   isEdit: state.editMode,
      //   id: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
      //   isConform: state.isApprove,
      // };

      case 3:
        return {
          flag: "Photo",
        };
      case 4:
        return {
          flag: "Prices",
          // dailyRate: values.DailyPrices,
          // minimumBookingHours: values.minimumBookingHours ? values.minimumBookingHours : "1",
          // hourlyLimit: values.HourlyLimit,
          // cancellationFee: values.cancellationFee,
          // cancellationPolicy: values.CancellationPolicy,
          serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
          // capacity: parkingSlotCapacity,
          isEdit: state.editMode,
          id: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
          // dailyLimit: "0",
          // hourlyRate: values.hourlyRate,
          // cancellationDueTime: values.cancellationDueTime,
          // tierType: "0",
          parkingTypeId: values.parkingTypeId.map((p: any) => Number(p)),
          // parkingCategory: values.parkingCategory,
          salesTax: values.CGST,
          // countyTax: "0",
          stateTax: values.SGST,
          // fixedFee: values.fixedFee,
          isConform: state.isApprove,
        };

      case 5:
        return {
          flag: "BlackoutDate",
          serviceProviderId: selectedOptions?.id,
          isEdit: state.editMode,
          id: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
          isConform: state.isApprove,
        };

      case 6:
        return {
          flag: "Amenities",
          amenitiesList: values.amenities,
          serviceProviderId: state.isAdmin || state.isApprove ? selectedOptions?.id : authData.serviceProviderId,
          isEdit: state.editMode,
          id: state.editMode ? state.id : state.isApprove ? state.id : selectedParkingLocationId,
          isConform: state.isApprove,
          // status: state.isAdmin === false && state.editMode === false ? values.status : true,
        };
      case 7:
        return {
          flag: "Instructions",
          isEdit: false,
          status: state.isAdmin === false && state.editMode === false ? values.status : true,
          id: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
          isConform: state.isApprove,
          cancellationPolicy: values.CancellationPolicy,
          specialInstructions: values.Specialinstructionsforemailconfirmation,
          inclusions: values.inclusions,
          exclusions: values.exclusions,

        };
      // case 7:
      //   return {
      //     flag: "Time",
      //     isEdit: false,
      //     status: state.isAdmin === false && state.editMode === false ? values.status : true,
      //     operationHoursList: values.operationHoursList,
      //     id: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
      //     isConform: state.isApprove,
      //   };
      case "saveVehicle":
        return {
          flag: "Vehicle",
          chassisNumber: values.chassisNumber,
          color: values.color,
          engineNumber: values.engineNumber,
          insuranceExpiryDate: values.insuranceExpiryDate,
          vehicleExpiryDate: values.vehicleExpiryDate,
          make: values.make,
          manufacturer: values.manufacturer,
          mileage: values.mileage,
          model: values.model,
          registrationNumber: values.registrationNumber,
          seatingCapacity: values.seatingCapacity,
          luggageCapacity: values.luggageCapacity,
          type: values.type,
          year: values.year,
          fuelType: values.fuelType,
          gearType: values.gearType,
          isAc: values.isAc == "true" ? true : false,
          parkingSpaceLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
          id: state.editMode || state.isApprove ? selectedVehicleDetailsId : null,
          permitType: values.permitType || null,
          permitNumber: values.permitType ? values.permitNumber : null,
          isFastag: values.isFastag == "Yes" ? true : false,
          isVerified: values.isVerified == "Yes" ? true : false,
          carrierAvailability: values.carrierAvailability == "Yes" ? true : false
        };
      default:
        return "unknown step";
    }
  }

  // const handleOperationMode = (event: any, index: number) => {
  //   operationHoursList[index] = typeof operationHoursList[index] !== "undefined" ? { ...operationHoursList[index] } : {};
  //   operationHoursList[index]["fromTime"] = typeof operationHoursList[index] !== "undefined" ? operationHoursList[index].fromTime : "";

  //   operationHoursList[index]["toTime"] = typeof operationHoursList[index] !== "undefined" ? operationHoursList[index].toTime : "";
  //   operationHoursList[index]["operationalStatus"] = event.target.value;
  //   operationHoursList[index]["dayOfWeek"] = GET_DAYS[index];
  //   operationHoursList[index]["dayId"] = index;
  //   operationHoursList[index]["id"] = formValues.operationHoursList[index].id;
  //   operationHoursList[index]["parkingLocationId"] = state.editMode ? state.id : state.isApprove ? state.id : selectedParkingLocationId;
  //   SetOperationHoursList(() => [...operationHoursList]);
  //   setFormValues(() => {
  //     return { ...formValues, operationHoursList: [...operationHoursList] };
  //   });
  // };
  // const handleOperationTime = (event: any, index: number) => {
  //   operationHoursList[index] = typeof operationHoursList[index] !== "undefined" ? { ...operationHoursList[index] } : {};
  //   operationHoursList[index]["fromTime"] =
  //     event?.target?.name === "fromTime"
  //       ? new Date(event?.target?.value)
  //       : typeof operationHoursList[index] !== "undefined" && operationHoursList[index].fromTime;

  //   operationHoursList[index]["toTime"] =
  //     event?.target?.name === "toTime" ? new Date(event?.target?.value) : typeof operationHoursList[index] !== "undefined" && operationHoursList[index].toTime;

  //   operationHoursList[index]["operationalStatus"] = typeof operationHoursList[index] !== "undefined" && operationHoursList[index].operationalStatus;
  //   operationHoursList[index]["dayOfWeek"] = GET_DAYS[index];
  //   operationHoursList[index]["dayId"] = index;
  //   operationHoursList[index]["id"] = formValues.operationHoursList[index].id;
  //   operationHoursList[index]["parkingLocationId"] = state.editMode ? state.id : state.isApprove ? state.id : selectedParkingLocationId;
  //   SetOperationHoursList(() => [...operationHoursList]);
  //   setFormValues(() => {
  //     return { ...formValues, operationHoursList: [...operationHoursList] };
  //   });
  // };

  useEffect(() => {
    if (state.editMode || state.isApprove) {
      findParkingSpaceLocationById({
        token: token,
        id: state.id,
        customerId: authData.userId,
      });
      findByParkingLocationId({
        parkingLocationId: state.id,
        token: token,
      });
    }
  }, [state.editMode, state.isApprove]);

  useEffect(() => {
    if (findParkingSpaceLocationByIdResponse.isSuccess) {
      setUpdateState(findParkingSpaceLocationByIdResponse.data);
      setServiceProviders([findParkingSpaceLocationByIdResponse?.data?.serviceProviderDetailResponseDTO]);
      setIsPinRequired(findParkingSpaceLocationByIdResponse.data?.isPinRequired);
      setSelectedVehicleDetailsId(findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.id);
      setFormValues(() => {
        return {
          chassisNumber: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.chassisNumber,
          color: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.color,
          engineNumber: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.engineNumber,
          insuranceExpiryDate: new Date(findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.insuranceExpiryDate),
          vehicleExpiryDate: new Date(findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.vehicleExpiryDate),
          make: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.make,
          manufacturer: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.manufacturer,
          mileage: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.mileage,
          model: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.model,
          registrationNumber: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.registrationNumber,
          seatingCapacity: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.seatingCapacity,
          luggageCapacity: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.luggageCapacity,
          type: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.type,
          year: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.year,
          fuelType: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.fuelType,
          gearType: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.gearType,
          isAc: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.isAc == false ? "false" : findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.isAc == true ? "true" : findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.isAc,
          address: findParkingSpaceLocationByIdResponse.data?.address || "",
          latitude: findParkingSpaceLocationByIdResponse.data?.latitude,
          longitude: findParkingSpaceLocationByIdResponse.data?.longitude,
          stateName: findParkingSpaceLocationByIdResponse.data?.stateName,
          countryName: findParkingSpaceLocationByIdResponse.data?.countryName,
          cityName: findParkingSpaceLocationByIdResponse.data?.cityName,
          Apartment: findParkingSpaceLocationByIdResponse.data?.apartmentNo || "",
          serviceProviderId: findParkingSpaceLocationByIdResponse.data?.serviceProviderId,
          Email: findParkingSpaceLocationByIdResponse.data?.contactEmail || "",
          firstName: findParkingSpaceLocationByIdResponse.data?.contactFirstName || "",
          lastName: findParkingSpaceLocationByIdResponse.data?.contactLastName || "",
          phoneNumber: findParkingSpaceLocationByIdResponse.data?.phoneNumber || "",
          GSTno: findParkingSpaceLocationByIdResponse.data?.parentCompanyDba || "",
          PANno: findParkingSpaceLocationByIdResponse.data?.parentCompanyEin || "",
          NameOfParentCompany: findParkingSpaceLocationByIdResponse.data?.parentCompanyName || "",
          // ListingDescription: findParkingSpaceLocationByIdResponse.data?.listingDescription || "",
          // ListingInstruction: findParkingSpaceLocationByIdResponse.data?.listingInstruction || "",
          // ListingName: findParkingSpaceLocationByIdResponse.data?.listingName || "",
          // isPinRequired: findParkingSpaceLocationByIdResponse.data?.isPinRequired,
          // parkingPin: findParkingSpaceLocationByIdResponse.data?.parkingPin || "",
          CancellationPolicy: findParkingSpaceLocationByIdResponse.data?.cancellationPolicy || "",
          Specialinstructionsforemailconfirmation: findParkingSpaceLocationByIdResponse.data?.specialInstructions || "",
          inclusions: findParkingSpaceLocationByIdResponse.data?.inclusions || "",
          exclusions: findParkingSpaceLocationByIdResponse.data?.exclusions || "",
          // HourlyLimit: findParkingSpaceLocationByIdResponse.data?.hourlyLimit || "0",
          cancellationFee: findParkingSpaceLocationByIdResponse.data?.cancellationFee || "0",
          // DailyPrices: findParkingSpaceLocationByIdResponse.data?.dailyRate || "0",
          // minimumBookingHours: findParkingSpaceLocationByIdResponse.data?.minimumBookingHours || "2",
          // NumberOfSlotavailable: findParkingSpaceLocationByIdResponse.data?.capacity || "",
          amenities: findParkingSpaceLocationByIdResponse.data?.amenitiesList ? findParkingSpaceLocationByIdResponse.data?.amenitiesList : [],
          // operationHoursList: findParkingSpaceLocationByIdResponse.data?.operationHoursList
          //   ? findParkingSpaceLocationByIdResponse.data?.operationHoursList
          //   : operationHoursList,
          // dailyLimit: findParkingSpaceLocationByIdResponse.data?.dailyLimit || "0",
          // hourlyRate: findParkingSpaceLocationByIdResponse.data?.hourlyRate || "0",
          cancellationDueTime: findParkingSpaceLocationByIdResponse.data?.cancellationDueTime || "0",
          // tierType: findParkingSpaceLocationByIdResponse.data.tierType || '',
          parkingTypeId: findParkingSpaceLocationByIdResponse.data.parkingTypeParkingSpaceLocationMappings?.map((v: any) => (v?.parkingTypeObj?.id).toString()) || [],
          status: findParkingSpaceLocationByIdResponse.data.status,
          parkingCategory: findParkingSpaceLocationByIdResponse.data.parkingCategory || "0",
          CGST: findParkingSpaceLocationByIdResponse.data.salesTax || "0",
          SGST: findParkingSpaceLocationByIdResponse.data.stateTax || "0",
          // fixedFee: findParkingSpaceLocationByIdResponse.data.fixedFee || "0",
          IGST: findParkingSpaceLocationByIdResponse.data.countyTax || "0",
          // fromTimeString: findParkingSpaceLocationByIdResponse.data.fromTimeString || "",
          // toTimeString: findParkingSpaceLocationByIdResponse.data.toTimeString || "",
          bookingType: findParkingSpaceLocationByIdResponse.data.bookingType || "",
          // bookingUnits: findParkingSpaceLocationByIdResponse.data.bookingUnits || "",
          commExtraRate: findParkingSpaceLocationByIdResponse.data.commExtraRate || "0",
          commRate: findParkingSpaceLocationByIdResponse.data.commRate || "0",
          permitType: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.permitType || '',
          permitNumber: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.permitNumber || '',
          isFastag: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.isFastag ?
            findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.isFastag == true ? "Yes" : "No" : '',
          isVerified: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.isVerified ?
            findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.isVerified == true ? "Yes" : "No" : '',
          carrierAvailability: findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.carrierAvailability ?
            findParkingSpaceLocationByIdResponse.data?.vehicleDetailObj?.carrierAvailability == true ? "Yes" : "No" : ''
        };
      });
    }
  }, [findParkingSpaceLocationByIdResponse.isSuccess]);

  const handleSubmit = (values: any) => {
    console.log("formValues: ", formValues)
    if (activeStep === 3) {
      setActiveStep(activeStep + 1);
    } else {
      if (activeStep === 0) {
        saveParkingDataToServer(values);
      } else if (activeStep === 2) {
        saveVehicleDetailsToServer(values);
      }
      // else if (activeStep === 7) {
      //   SaveTimeToServer(values);
      //   navigate(state.isAdmin == false ? '/dashboard/vehicleoverview' : '/dashboard/all-parking-spaces');
      // }
      else {
        if (activeStep !== 5) {
          UpdateParkingDataToServer(values);
        } else {
          setActiveStep(activeStep + 1);
        }
      }
      setFormValues(values);
    }
    setSkippedSteps(skippedSteps.filter((skipItem: any) => skipItem !== activeStep));
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    findParkingSpaceLocationById({
      token: token,
      id: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
      customerId: authData.userId,
    });
    findByParkingLocationId({
      parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
      token: token,
    });
  };

  const deleteImage = (imageId: any) => {
    deleteParkingSpaceLocationImage({
      token: token,
      id: imageId,
    });
  };

  useEffect(() => {
    if (deleteParkingSpaceLocationImageResponse.isSuccess) {
      findByParkingLocationId({
        parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
        token: token,
      });
    }
  }, [deleteParkingSpaceLocationImageResponse.isSuccess]);

  useEffect(() => {
    if (state.editMode || state.isApprove || selectedParkingLocationId !== null) {
      getBlackoutDates({
        token: token,
        payload: {
          page: page,
          orderBy: order,
          offset: rowsPerPage,
          parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
        },
      });
    }
  }, []);

  useEffect(() => {
    if (getBlackoutDatesResponse.isSuccess) {
      dispatch(setBlackoutDay(getBlackoutDatesResponse.data));
    }
  }, [getBlackoutDatesResponse.isSuccess]);

  useEffect(() => {
    if (getBlackoutData) {
      setBlackoutData(getBlackoutData);
    }
  }, [getBlackoutData]);

  const handleFilterByName = (event: any) => {
    setFilterName(event.target.value);
    getBlackoutDates({
      token: token.token,
      payload: { offset: rowsPerPage, page: page, searchValue: event.target.value },
    });
  };

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: any) => {
    if (event.target.checked) {
      return;
    }
    setSelected([]);
  };

  const saveBlackoutDay = (values: any, action: any) => {
    saveBlackoutDate({
      payload: {
        date: values.date,
        description: values.description,
        parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
        status: true,
      },
      token: token,
    });
    action.resetForm();
  };

  useEffect(() => {
    if (saveBlackoutDateResponse.isSuccess) {
      setBlackoutDateId(saveBlackoutDateResponse.data.id);
      getBlackoutDates({
        token: token,
        payload: {
          page: page,
          orderBy: order,
          offset: rowsPerPage,
          parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
        },
      });
      toast.success("Blackout date added successfully");
    }
  }, [saveBlackoutDateResponse.isSuccess]);

  const updateBlackoutDay = (id: any, date: any, description: any, status: any) => {
    updateBlackoutDate({
      token: token,
      payload: {
        id: id,
        parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
        date: date,
        description: description,
        status: status === true ? false : true,
      },
    });
  };

  useEffect(() => {
    if (updateBlackoutDateResponse.isSuccess) {
      getBlackoutDates({
        token: token,
        payload: {
          page: page,
          orderBy: order,
          offset: rowsPerPage,
          parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
        },
      });
    }
  }, [updateBlackoutDateResponse.isSuccess]);

  const selectServiceProvider = (event: any) => {
    setServiceProviderName(event);
    getAllServiceProviderDetail({
      token: token,
      payload: { offset: 100, page: page, vendorAlias: event, currentStatus: "Approved" },
    });
  };

  useEffect(() => {
    getAllServiceProviderDetail({
      token: token,
      payload: { offset: 100, page: page, currentStatus: "Approved" },
    });
  }, []);

  useEffect(() => {
    if (serviceProviderResponse.isSuccess) {
      setServiceProviders(serviceProviderResponse.data.data);
    }
  }, [serviceProviderResponse.isSuccess]);

  const filteredUsers = blackoutData;
  const isUserNotFound = filteredUsers.length === 0;

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };
  return (
    <div>
      <Card>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={"25px"} marginLeft={"35px"} marginTop={"25px"}>
          <Typography variant="h4" gutterBottom>
            {state.editMode ? "Update Vehicle Details" : state.isApprove ? "Confirm Vehicle Details" : "Add Vehicle Details"}
          </Typography>

          <Button
            variant="contained"
            style={{ color: "white", backgroundColor: "#E23744" }}
            onClick={() => {
              state.isApprove
                ? navigate("/dashboard/new-vehicle-requests")
                : state.isAdmin
                  ? navigate("/dashboard/all-vehicle-spaces")
                  : navigate("/dashboard/vehicle-overview");
            }}
            sx={{ marginBottom: "10px" }}
            size="medium">
            <ArrowBackIcon />
          </Button>
        </Stack>
        {state.editMode || state.isApprove ? (
          <Stepper nonLinear activeStep={activeStep} >
            {steps.map((step, index) => {
              const stepProps = {};
              return (
                <Step {...stepProps} key={index}>
                  <StepLabel style={{ cursor: " pointer" }} onClick={handleStep(index)}>
                    {step}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
        ) : (
          <Stepper nonLinear activeStep={activeStep}>
            {steps.map((step, index) => {
              const labelProps = {};
              const stepProps = {};
              return (
                <Step {...stepProps} key={index}>
                  <StepLabel {...labelProps} >
                    {step}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
        )}

        <Formik
          initialValues={formValues}
          enableReinitialize={true}
          validate={validate[activeStep]}
          onSubmit={handleSubmit}
          render={({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              {activeStep === 0 && (
                <Location
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  serviceProviders={serviceProviders}
                  setAddress={setAddress}
                  state={state}
                  authDetail={authDetail}
                  setSelectedOptions={setSelectedOptions}
                  selectServiceProvider={selectServiceProvider}
                  serviceProviderName={serviceProviderName}
                  updateState={updateState}
                />
              )}
              {activeStep === 1 && (
                <Contact
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  updateState={updateState}
                  state={state}
                  findParkingSpaceLocationByIdResponse={findParkingSpaceLocationByIdResponse}
                />
              )}
              {activeStep === 2 && (
                // <Overview
                //   values={values}
                //   errors={errors}
                //   handleChange={handleChange}
                //   handleBlur={handleBlur}
                //   updateState={updateState}
                //   state={state}
                //   content={content}
                //   setContent={setContent}
                //   editor={editor}
                //   contentOne={contentOne}
                //   setContentOne={setContentOne}
                //   setIsPinRequired={setIsPinRequired}
                //   isPinRequired={isPinRequired}
                //   contentTwo={contentTwo}
                //   setContentTwo={setContentTwo}
                //   contentThree={contentThree}
                //   setContentThree={setContentThree}
                //   formValues={formValues}
                //   validate={validate}
                //   setFieldValue={setFieldValue}
                //   config={config}
                // />
                <Vehicle
                  values={values}
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  state={state}
                  permitTypeEnum={permitTypeEnum}
                  carTypeEnum={carTypeEnum}
                  fuelTypeEnum={fuelTypeEnum}
                  gearTypeEnum={gearTypeEnum}
                />
              )}
              {activeStep === 3 && (
                <Photo
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  isImgUrl={isImgUrl}
                  setIsImgUrl={setIsImgUrl}
                  cityImage={cityImage}
                  setCityImage={setCityImage}
                  permitImage={permitImage}
                  setPermitImage={setPermitImage}
                  uploadImages={uploadImages}
                  uploadedImage={uploadedImage}
                  uploadedPermitImage={uploadedPermitImage}
                  deleteImage={deleteImage}
                  isPermitImageUploaded={isPermitImageUploaded}
                />
              )}
              {activeStep === 4 && (
                <Prices
                  values={values}
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  tierType={tierType}
                  parkingManagementData={parkingManagementData}
                  parkingCategory={parkingCategory}
                  state={state}
                  formValues={formValues}
                  setFormValues={setFormValues}
                  validate={validate[activeStep]}
                  navigate={navigate}
                  saveParkingCategoryDetail={saveParkingCategoryDetail}
                  token={token}
                  updateParkingCategoryDetail={updateParkingCategoryDetail}
                  getParkingCategoryDetail={getParkingCategoryDetail}
                  saveParkingCategoryDetailResponse={saveParkingCategoryDetailResponse}
                  updateParkingCategoryDetailResponse={updateParkingCategoryDetailResponse}
                  getParkingCategoryDetailResponse={getParkingCategoryDetailResponse}
                  getCategoryList={getCategoryList}
                  getCategoryListResponse={getCategoryListResponse}
                  getSubCategoryList={getSubCategoryList}
                  getSubCategoryListResponse={getSubCategoryListResponse}
                  selectedParkingLocationId={selectedParkingLocationId}
                  rowdata={rowdata}
                  setFieldValue={setFieldValue}
                  bookingTypeEnum={bookingTypeEnum}
                />
              )}

              {activeStep === 5 && (
                <BlackoutDate
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  selected={selected}
                  order={order}
                  orderBy={orderBy}
                  filterName={filterName}
                  handleFilterByName={handleFilterByName}
                  handleRequestSort={handleRequestSort}
                  blackoutData={blackoutData}
                  handleSelectAllClick={handleSelectAllClick}
                  filteredUsers={filteredUsers}
                  isUserNotFound={isUserNotFound}
                  blackoutForm={blackoutForm}
                  saveBlackoutDay={saveBlackoutDay}
                  updateBlackoutDay={updateBlackoutDay}
                />
              )}

              {activeStep === 6 && (
                <Amentities values={values} errors={errors} handleChange={handleChange} handleBlur={handleBlur} marchantType={marchantType} />
              )}

              {activeStep === 7 && (
                // <Time
                //   values={values}
                //   errors={errors}
                //   handleChange={handleChange}
                //   handleBlur={handleBlur}
                //   handleOperationMode={handleOperationMode}
                //   handleOperationTime={handleOperationTime}
                //   state={state}
                // />
                <Instructions values={values}
                  errors={errors}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  state={state}
                  setFieldValue={setFieldValue}
                  contentTwo={contentTwo}
                  setContentTwo={setContentTwo}
                  contentThree={contentThree}
                  setContentThree={setContentThree}
                  contentFour={contentFour}
                  setContentFour={setContentFour}
                  contentFive={contentFive}
                  setContentFive={setContentFive}
                />
              )}
              <Box display={"flex"} justifyContent={"end"} padding={4}>
                <Box>
                  <Button className={classes.button} disabled={activeStep === 0} onClick={handleBack}>
                    Back
                  </Button>
                </Box>
                <Box>
                  <Button
                    type="submit"
                    className={classes.button}
                    style={{ color: "white", backgroundColor: "#E23744" }}
                    variant="contained"
                    color="primary"
                    disabled={
                      activeStep === 3
                        ? uploadedImage == 0 || (uploadedImage == null && flag == false && condition == false)
                          ? true
                          : false
                        : activeStep === 4 && rowdata.length == 0
                          ? true
                          : false
                    }>
                    {activeStep === steps.length - 1 ? (state.isApprove ? " Confirm" : "Finish") : "Next"}
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        />
      </Card>
      {updateResponse.isLoading ||
        saveResponse.isLoading ||
        saveVehicleDetailsResponse.isLoading ||
        serviceProviderResponse.isLoading ||
        ParkingSpaceLocationImageResponse.isLoading ||
        findByParkingLocationIdResponse.isLoading ||
        getParkingTypeDataResponse.isLoading ||
        saveBlackoutDateResponse.isLoading ||
        getBlackoutDatesResponse.isLoading ||
        updateBlackoutDateResponse.isLoading ||
        findParkingSpaceLocationByIdResponse.isLoading ||
        getParkingTypeDataResponse.isLoading ||
        deleteParkingSpaceLocationImageResponse.isLoading ? (
        <Loading />
      ) : null}
    </div>
  );
};

export default VehicleForm;

const validate: any = {
  0: (values: any) => {
    const errors: any = {};
    if (!values.serviceProviderId) errors["serviceProviderId"] = "This field is required";

    return errors;
  },
  1: (values: any) => {
    const errors: any = {};
    if (!/^([a-zA-Z]{3,50}\s*)+/.test(values.firstName)) errors["firstName"] = "Invaild first name";
    if (!values.firstName) errors["firstName"] = "This field is required";
    if (!/^([a-zA-Z]{3,50}\s*)+/.test(values.lastName)) errors["lastName"] = "Invaild last name";
    if (!values.lastName) errors["lastName"] = "This field is required";
    if (!values.phoneNumber) errors["phoneNumber"] = "This field is required";
    if (!/^[1-9]\d*(\d+)?$/i.test(values.phoneNumber)) errors["phoneNumber"] = "Only number allow ";
    if (values.phoneNumber.length !== 10) errors["phoneNumber"] = "Phone number must be 10 digit";
    if (values.phoneNumber.length > 11) errors["phoneNumber"] = "Phone number maximum 11 digit";
    if (!values.Email) errors["Email"] = "This field is required";
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i.test(values.Email)) errors["Email"] = "Enter valid email";
    if (!values.GSTno) errors["GSTno"] = "This field is required";
    if (!/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(values.GSTno)) errors["GSTno"] = "GST number is not valid";
    if (!values.PANno) errors["PANno"] = "This field is required";
    if (!/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(values.PANno)) errors["PANno"] = "Pan card number is not valid";
    return errors;
  },
  2: (values: any) => {
    const errors: any = {};
    if (!values.chassisNumber) errors["chassisNumber"] = "This field is required";
    if (!values.color) errors["color"] = "This field is required";
    if (!values.engineNumber) errors["engineNumber"] = "This field is required";
    if (!values.insuranceExpiryDate) {
      errors["insuranceExpiryDate"] = "This field is required";
    } else {
      const selectedDate = new Date(values.insuranceExpiryDate);
      const today = new Date();
      selectedDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (selectedDate <= today) {
        errors["insuranceExpiryDate"] = "Please select a future date";
      }
    }
    if (!values.vehicleExpiryDate) {
      errors["vehicleExpiryDate"] = "This field is required";
    } else {
      const selectedDate = new Date(values.vehicleExpiryDate);
      const today = new Date();

      selectedDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (selectedDate <= today) {
        errors["vehicleExpiryDate"] = "Please select a future date";
      }
    }
    if (!values.make) errors["make"] = "This field is required";
    if (!values.manufacturer) errors["manufacturer"] = "This field is required";
    if (!values.mileage) errors["mileage"] = "This field is required";
    if (!values.model) errors["model"] = "This field is required";
    if (!values.registrationNumber) errors["registrationNumber"] = "This field is required";
    if (!values.seatingCapacity) errors["seatingCapacity"] = "This field is required";
    if (!values.luggageCapacity) errors["luggageCapacity"] = "This field is required";
    if (!values.type) errors["type"] = "This field is required";
    if (!values.year) errors["year"] = "This field is required";
    if (!values.fuelType) errors["fuelType"] = "This field is required";
    if (!values.gearType) errors["gearType"] = "This field is required";
    if (!values.isAc) errors["isAc"] = "This field is required";
    if (values.permitType && !values.permitNumber) errors["permitNumber"] = "This field is required";
    if (values.isFastag && !values.isFastag) errors["isFastag"] = "This field is required";
    if (values.isVerified && !values.isVerified) errors["isVerified"] = "This field is required";
    if (values.carrierAvailability && !values.carrierAvailability) errors["carrierAvailability"] = "This field is required";

    return errors;
  },

  3: () => {
    const errors: any = {};
    return errors;
  },

  4: (values: any) => {
    const errors: any = {};
    if (!values.parkingTypeId) errors['parkingTypeId'] = 'This field is required';
    // if (!values.parkingCategory) errors['parkingCategory'] = 'This field is required';
    if (!values.CGST) errors["CGST"] = "This field is required";
    if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.CGST)) errors["CGST"] = "Invalid number";
    if (!values.SGST) errors["SGST"] = "This field is required";
    if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.SGST)) errors["SGST"] = "Invalid number";
    // if (!values.fixedFee) errors["fixedFee"] = "This field is required";
    // if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.fixedFee)) errors["fixedFee"] = "Invalid number";
    return errors;
  },

  5: () => {
    const errors: any = {};

    return errors;
  },

  6: () => {
    const errors: any = {};

    return errors;
  },

  7: (values: any) => {
    const errors: any = {};
    // if (!values?.operationHoursList[0].operationalStatus) errors["operationHoursList[0].operationalStatus"] = "This field is required";
    // if (!values?.operationHoursList[1].operationalStatus) errors["operationHoursList[1].operationalStatus"] = "This field is required";
    // if (!values?.operationHoursList[2].operationalStatus) errors["operationHoursList[2].operationalStatus"] = "This field is required";
    // if (!values?.operationHoursList[3].operationalStatus) errors["operationHoursList[3].operationalStatus"] = "This field is required";
    // if (!values?.operationHoursList[4].operationalStatus) errors["operationHoursList[4].operationalStatus"] = "This field is required";
    // if (!values?.operationHoursList[5].operationalStatus) errors["operationHoursList[5].operationalStatus"] = "This field is required";
    // if (!values?.operationHoursList[6].operationalStatus) errors["operationHoursList[6].operationalStatus"] = "This field is required";

    // if (values?.operationHoursList[0].operationalStatus === "range" && !values?.operationHoursList[0].fromTime)
    //   errors["operationHoursList[0].fromTime"] = "This field is required";
    // if (values?.operationHoursList[1].operationalStatus === "range" && !values?.operationHoursList[1].fromTime)
    //   errors["operationHoursList[1].fromTime"] = "This field is required";
    // if (values?.operationHoursList[2].operationalStatus === "range" && !values?.operationHoursList[2].fromTime)
    //   errors["operationHoursList[2].fromTime"] = "This field is required";
    // if (values?.operationHoursList[3].operationalStatus === "range" && !values?.operationHoursList[3].fromTime)
    //   errors["operationHoursList[3].fromTime"] = "This field is required";
    // if (values?.operationHoursList[4].operationalStatus === "range" && !values?.operationHoursList[4].fromTime)
    //   errors["operationHoursList[4].fromTime"] = "This field is required";
    // if (values?.operationHoursList[5].operationalStatus === "range" && !values?.operationHoursList[5].fromTime)
    //   errors["operationHoursList[5].fromTime"] = "This field is required";
    // if (values?.operationHoursList[6].operationalStatus === "range" && !values?.operationHoursList[6].fromTime)
    //   errors["operationHoursList[6].fromTime"] = "This field is required";

    // if (values?.operationHoursList[0].operationalStatus === "range" && !values?.operationHoursList[0].toTime)
    //   errors["operationHoursList[0].toTime"] = "This field is required";
    // if (values?.operationHoursList[1].operationalStatus === "range" && !values?.operationHoursList[1].toTime)
    //   errors["operationHoursList[1].toTime"] = "This field is required";
    // if (values?.operationHoursList[2].operationalStatus === "range" && !values?.operationHoursList[2].toTime)
    //   errors["operationHoursList[2].toTime"] = "This field is required";
    // if (values?.operationHoursList[3].operationalStatus === "range" && !values?.operationHoursList[3].toTime)
    //   errors["operationHoursList[3].toTime"] = "This field is required";
    // if (values?.operationHoursList[4].operationalStatus === "range" && !values?.operationHoursList[4].toTime)
    //   errors["operationHoursList[4].toTime"] = "This field is required";
    // if (values?.operationHoursList[5].operationalStatus === "range" && !values?.operationHoursList[5].toTime)
    //   errors["operationHoursList[5].toTime"] = "This field is required";
    // if (values?.operationHoursList[6].operationalStatus === "range" && !values?.operationHoursList[6].toTime)
    //   errors["operationHoursList[6].toTime"] = "This field is required";
    if (!values.CancellationPolicy) errors["CancellationPolicy"] = "This field is required";
    if (!values.Specialinstructionsforemailconfirmation) errors["Specialinstructionsforemailconfirmation"] = "This field is required";
    if (!values.inclusions) errors["inclusions"] = "This field is required";
    if (!values.exclusions) errors["exclusions"] = "This field is required";

    return errors;
  },
};

const Vehicle = ({ values, errors, touched, handleChange, handleBlur, setFieldValue, state, permitTypeEnum, carTypeEnum, fuelTypeEnum, gearTypeEnum }: any) => {
  return (
    <div>
      <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
        <Box>
          <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Vehicle Details</p>
        </Box>
        <Box marginTop={"25px"}>
          <Typography variant="h3" marginBottom={"20px"} component="div"></Typography>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Box marginTop={"25px"} flex={1} marginRight={2}>
              <TextField
                fullWidth
                id="chassisNumber"
                label="Chassis Number"
                value={values.chassisNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                name="chassisNumber"
                error={Boolean(touched.chassisNumber && errors.chassisNumber)}
                helperText={touched.chassisNumber && errors.chassisNumber}
                disabled={state?.parkingSpace?.currentStatus === "active" && state?.isAdmin === false ? true : false}
              />
            </Box>
            <Box marginTop={"25px"} flex={1}>
              <TextField
                fullWidth
                id="engineNumber"
                label="Engine Number"
                value={values.engineNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                name="engineNumber"
                error={Boolean(touched.engineNumber && errors.engineNumber)}
                helperText={touched.engineNumber && errors.engineNumber}
                disabled={state?.parkingSpace?.currentStatus === "active" && state?.isAdmin === false ? true : false}
              />
            </Box>
          </Stack>

          <Stack direction={"row"} justifyContent={"space-between"}>
            <Box marginTop={"25px"} flex={1} marginRight={2}>
              <TextField
                fullWidth
                id="registrationNumber"
                label="Registration Number"
                value={values.registrationNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                name="registrationNumber"
                error={Boolean(touched.registrationNumber && errors.registrationNumber)}
                helperText={touched.registrationNumber && errors.registrationNumber}
                disabled={state?.parkingSpace?.currentStatus === "active" && state?.isAdmin === false ? true : false}
              />
            </Box>

            <Box marginTop={"25px"} flex={1}>
              <TextField
                fullWidth
                id="manufacturer"
                label="Manufacturer"
                value={values.manufacturer}
                onChange={handleChange}
                onBlur={handleBlur}
                name="manufacturer"
                error={Boolean(touched.manufacturer && errors.manufacturer)}
                helperText={touched.manufacturer && errors.manufacturer}
                disabled={state?.parkingSpace?.currentStatus === "active" && state?.isAdmin === false ? true : false}
              />
            </Box>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Box marginTop={"25px"} flex={1} marginRight={2}>
              <TextField
                fullWidth
                id="make"
                label="Make"
                value={values.make}
                onChange={handleChange}
                onBlur={handleBlur}
                name="make"
                error={Boolean(touched.make && errors.make)}
                helperText={touched.make && errors.make}
                disabled={state?.parkingSpace?.currentStatus === "active" && state?.isAdmin === false ? true : false}
              />
            </Box>

            <Box marginTop={"25px"} flex={1}>
              <TextField
                fullWidth
                id="model"
                label="Model"
                value={values.model}
                onChange={handleChange}
                onBlur={handleBlur}
                name="model"
                error={Boolean(touched.model && errors.model)}
                helperText={touched.model && errors.model}
                disabled={state?.parkingSpace?.currentStatus === "active" && state?.isAdmin === false ? true : false}
              />
            </Box>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Box marginTop={"25px"} marginRight={2} flex={1}>
              <TextField
                fullWidth
                id="seatingCapacity"
                label="Seating Capacity"
                value={values.seatingCapacity}
                onChange={handleChange}
                onBlur={handleBlur}
                name="seatingCapacity"
                type="number"
                error={Boolean(touched.seatingCapacity && errors.seatingCapacity)}
                helperText={touched.seatingCapacity && errors.seatingCapacity}
              />
            </Box>
            <Box marginTop={"25px"} flex={1}>
              <TextField
                fullWidth
                id="luggageCapacity"
                label="Luggage Capacity"
                value={values.luggageCapacity}
                onChange={handleChange}
                onBlur={handleBlur}
                name="luggageCapacity"
                type="number"
                error={Boolean(touched.luggageCapacity && errors.luggageCapacity)}
                helperText={touched.luggageCapacity && errors.luggageCapacity}
              />
            </Box>
          </Stack>
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Box marginTop={"25px"} flex={1} marginRight={2}>
              <TextField
                fullWidth
                type="number"
                id="mileage"
                label="Mileage"
                value={values.mileage}
                onChange={handleChange}
                onBlur={handleBlur}
                name="mileage"
                error={Boolean(touched.mileage && errors.mileage)}
                helperText={touched.mileage && errors.mileage}
              />
            </Box>

            <Box marginTop={"25px"} flex={1}>
              <FormControl fullWidth>
                <InputLabel id="type">Type</InputLabel>
                <Select
                  name="type"
                  id="type"
                  label="Type"
                  value={values.type ? values.type : ""}
                  onChange={handleChange}
                  error={Boolean(touched.type && errors.type)}>
                  {carTypeEnum && carTypeEnum.map((type: any) =>
                    <MenuItem key={type?.code} value={type?.code}>{type?.displayValue}</MenuItem>
                  )}
                </Select>
                {touched.type && (
                  <FormHelperText style={{ color: "red" }} className="text-sm">
                    {errors.type}
                  </FormHelperText>
                )}
              </FormControl>
            </Box>
          </Stack>

          <Stack direction={"row"} justifyContent={"space-between"}>
            <Box marginTop={"25px"} marginRight={2} flex={1}>
              <FormControl fullWidth>
                <InputLabel id="fuelType">Fuel Type</InputLabel>
                <Select
                  name="fuelType"
                  id="fuelType"
                  label="Fuel Type"
                  value={values.fuelType ? values.fuelType : ""}
                  onChange={handleChange}
                  error={Boolean(touched.fuelType && errors.fuelType)}>
                  {fuelTypeEnum && fuelTypeEnum.map((fuel: any) =>
                    <MenuItem key={fuel?.code} value={fuel?.code}>{fuel?.code}</MenuItem>
                  )}
                </Select>
                {touched.fuelType && <FormHelperText style={{ color: "red" }}>{errors.fuelType}</FormHelperText>}
              </FormControl>
            </Box>
            <Box marginTop={"25px"} marginRight={2} flex={1}>
              <FormControl fullWidth>
                <InputLabel id="gearType">Gear Type</InputLabel>
                <Select
                  name="gearType"
                  id="gearType"
                  label="Gear Type"
                  value={values.gearType ? values.gearType : ""}
                  onChange={handleChange}
                  error={Boolean(touched.gearType && errors.gearType)}>
                  {gearTypeEnum && gearTypeEnum.map((gear: any) =>
                    <MenuItem key={gear?.code} value={gear?.code}>{gear?.code}</MenuItem>
                  )}
                </Select>
                {touched.gearType && <FormHelperText style={{ color: "red" }}>{errors.gearType}</FormHelperText>}
              </FormControl>
            </Box>
            <Box marginTop={"25px"} flex={1}>
              <TextField
                fullWidth
                id="year"
                label="Year"
                value={values.year}
                onChange={handleChange}
                onBlur={handleBlur}
                name="year"
                type="number"
                error={Boolean(touched.year && errors.year)}
                helperText={touched.year && errors.year}
              />
            </Box>
          </Stack>

          <Stack direction={"row"} justifyContent={"space-between"}>
            <Box marginTop={"25px"} flex={1} marginRight={2}>
              <FormControl fullWidth>
                <InputLabel id="isAc">AC / Non-AC</InputLabel>
                <Select
                  name="isAc"
                  id="isAc"
                  label="AC / Non-AC"
                  value={values.isAc ? values.isAc : ""}
                  onChange={handleChange}
                  error={Boolean(touched.isAc && errors.isAc)}
                  displayEmpty>
                  <MenuItem value="true">AC</MenuItem>
                  <MenuItem value="false">Non-AC</MenuItem>
                </Select>
                {touched.isAc && <FormHelperText style={{ color: "red" }}>{errors.isAc}</FormHelperText>}
              </FormControl>
            </Box>
            <Box marginTop={"25px"} flex={1} marginRight={2}>
              <TextField
                fullWidth
                id="color"
                label="Color"
                value={values.color}
                onChange={handleChange}
                onBlur={handleBlur}
                name="color"
                error={Boolean(touched.color && errors.color)}
                helperText={touched.color && errors.color}
              />
            </Box>
            <Box marginTop={"25px"} flex={1}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Insurance Expiry Date"
                  value={values.insuranceExpiryDate}
                  minDate={new Date()}
                  onChange={(e) => {
                    setFieldValue("insuranceExpiryDate", e);
                  }}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      id="insuranceExpiryDate"
                      name="insuranceExpiryDate"
                      style={{
                        borderColor: "blue",
                      }}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue("insuranceExpiryDate", e.target.value);
                      }}
                      {...params}
                      error={Boolean(touched.insuranceExpiryDate && errors.insuranceExpiryDate)}
                      helperText={touched.insuranceExpiryDate && errors.insuranceExpiryDate}
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
          </Stack>

          <Stack direction={"row"} justifyContent={"space-between"}>
            <Box marginTop={"25px"} marginRight={2}>
              <FormControl style={{ width: '200px' }}>
                <InputLabel id="permitType">Permit Type</InputLabel>
                <Select
                  name="permitType"
                  id="permitType"
                  label="Permit Type"
                  value={values.permitType ? values.permitType : ""}
                  onChange={handleChange}
                  error={Boolean(touched.permitType && errors.permitType)}>
                  <MenuItem value={''}>{'Select Permit Type'}</MenuItem>
                  {permitTypeEnum && permitTypeEnum.map((permit: any) => <MenuItem key={permit?.code} value={permit?.code}>{permit?.code}</MenuItem>)}
                </Select>
                {touched.permitType && <FormHelperText style={{ color: "red" }}>{errors.permitType}</FormHelperText>}
              </FormControl>
            </Box>
            {values.permitType && <Box marginTop={"25px"} marginRight={2} flex={1}>
              <TextField
                fullWidth
                id="permitNumber"
                label="Permit Number"
                value={values.permitNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                name="permitNumber"
                error={Boolean(touched.permitNumber && errors.permitNumber)}
                helperText={touched.permitNumber && errors.permitNumber}
              />
            </Box>}

            <Box marginTop={"25px"} flex={1}>
              <FormControl fullWidth>
                <InputLabel id="isFastag">Have Fastag?</InputLabel>
                <Select
                  name="isFastag"
                  id="isFastag"
                  label="Have Fastag?"
                  value={values.isFastag ? values.isFastag : ""}
                  onChange={handleChange}
                  error={Boolean(touched.isFastag && errors.isFastag)}>
                  <MenuItem value={''} disabled>{'Do you have fastag?'}</MenuItem>
                  <MenuItem value={'Yes'}>{'Yes'}</MenuItem>
                  <MenuItem value={'No'}>{'No'}</MenuItem>
                </Select>
                {touched.isFastag && <FormHelperText style={{ color: "red" }}>{errors.isFastag}</FormHelperText>}
              </FormControl>
            </Box>
          </Stack>

          <Stack direction={"row"} justifyContent={"space-between"}>

            <Box marginTop={"25px"} flex={1} marginRight={2}>
              <FormControl fullWidth>
                <InputLabel id="carrierAvailability">Carrier Availability?</InputLabel>
                <Select
                  name="carrierAvailability"
                  id="carrierAvailability"
                  label="Carrier Availability?"
                  value={values.carrierAvailability ? values.carrierAvailability : ""}
                  onChange={handleChange}
                  error={Boolean(touched.carrierAvailability && errors.carrierAvailability)}>
                  <MenuItem value={''} disabled>{'Is Carrier available in the vehicle?'}</MenuItem>
                  <MenuItem value={'Yes'}>{'Yes'}</MenuItem>
                  <MenuItem value={'No'}>{'No'}</MenuItem>
                </Select>
                {touched.carrierAvailability && <FormHelperText style={{ color: "red" }}>{errors.carrierAvailability}</FormHelperText>}
              </FormControl>
            </Box>

            <Box marginTop={"25px"} flex={1} marginRight={2}>
              <FormControl fullWidth>
                <InputLabel id="isVerified">Vehicle Verified?</InputLabel>
                <Select
                  name="isVerified"
                  id="isVerified"
                  label="Vehicle Verified?"
                  value={values.isVerified ? values.isVerified : ""}
                  onChange={handleChange}
                  error={Boolean(touched.isVerified && errors.isVerified)}>
                  <MenuItem value={''} disabled>{'Is the Vehicle Verified?'}</MenuItem>
                  <MenuItem value={'Yes'}>{'Yes'}</MenuItem>
                  <MenuItem value={'No'}>{'No'}</MenuItem>
                </Select>
                {touched.isVerified && <FormHelperText style={{ color: "red" }}>{errors.isVerified}</FormHelperText>}
              </FormControl>
            </Box>

            <Box marginTop={"25px"} flex={1}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Vehicle Expiry Date"
                  value={values.vehicleExpiryDate}
                  minDate={new Date()}
                  onChange={(e) => {
                    setFieldValue("vehicleExpiryDate", e);
                  }}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      id="vehicleExpiryDate"
                      name="vehicleExpiryDate"
                      style={{
                        borderColor: "blue",
                      }}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue("vehicleExpiryDate", e.target.value);
                      }}
                      {...params}
                      error={Boolean(touched.vehicleExpiryDate && errors.vehicleExpiryDate)}
                      helperText={touched.vehicleExpiryDate && errors.vehicleExpiryDate}
                    />
                  )}
                />
              </LocalizationProvider>
            </Box>
          </Stack>

        </Box>
      </Box>
    </div>
  );
};

const Location = ({
  values,
  errors,
  handleChange,
  handleBlur,
  serviceProviders,
  setAddress,
  state,
  authDetail,
  setSelectedOptions,
  selectServiceProvider,
  selectedOptions,
}: any) => {
  const [coords, setCoords] = useState<null | any>();
  const [currentLocation, setCurrentLocation] = useState<null | any>();
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function (position) {
      const currentCoords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      setCoords(currentCoords);
      setCurrentLocation(currentCoords);
    });
  }, []);
  const locationChange = (item: any) => {
    console.log("item", item);
    setAddress(item);
  };

  const selectItems = (option: any) => {
    if (option !== null && option !== undefined) {
      setSelectedOptions(option);
      // TODO:need to look up
    }
  };

  function getSelectedItem() {
    const item =
      serviceProviders &&
      serviceProviders.find((opt: any) => {
        if (opt?.currentStatus == "Approved" || opt.id == values.serviceProviderId) return opt;
      });
    if (item !== null && item !== undefined && item?.currentStatus == "Approved") {
      selectItems(item);
    }
    return item || null;
  }

  return (
    <div>
      <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
        <Box>
          <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Location Details</p>
        </Box>
        <Box marginTop={"25px"}>
          <Typography variant="h3" marginBottom={"20px"} component="div"></Typography>
          <LocationSearchInput locationDetail={(item: any) => locationChange(item)} value={values.address} />
          <Box marginTop={"25px"}>
            <TextField
              fullWidth
              id="Apartment"
              label="Apartment/ Building no"
              value={values.Apartment}
              onChange={handleChange}
              onBlur={handleBlur}
              name="Apartment"
            />
          </Box>
          {state.isAdmin == false ? (
            <Box marginTop={'25px'}>
              <InputLabel id="serviceProviderId">Vendor</InputLabel>
              <Box>
                <TextField
                  fullWidth
                  id="serviceProviderId"
                  value={authDetail?.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="serviceProviderId"
                  disabled={true}
                />
                {errors.serviceProviderId && <div style={{ color: 'red' }}>{errors.serviceProviderId}</div>}
              </Box>
            </Box>
          ) : (
            <Box marginTop={'25px'}>
              <InputLabel id="serviceProviderId">Vendor</InputLabel>
              <Autocomplete
                id="serviceProviderId"
                value={getSelectedItem()}
                options={serviceProviders}
                getOptionLabel={(item: any) => (item.vendorAlias ? `${item.vendorAlias}` : '')}
                style={{ width: '100%', marginTop: '30px' }}
                renderInput={(params) => <TextField {...params} label="Search vendor" variant="outlined" required />}
                onChange={(event: any, value: any) => {
                  if (value !== null && value !== '') {
                    selectItems(value);
                  }
                }}
                onInputChange={(event: any, value) => {
                  if (value !== null && value !== '' && value.length >= 3) {
                    selectServiceProvider(value);
                  }
                }}
                clearOnBlur={false}
                clearOnEscape={false}
              />
            </Box>
          )}
        </Box>
      </Box>
    </div>
  );
};

const Prices = ({
  values,
  errors,
  handleChange,
  handleBlur,
  // parkingCategory,
  parkingManagementData,
  state,
  saveParkingCategoryDetail,
  token,
  updateParkingCategoryDetail,
  getParkingCategoryDetail,
  saveParkingCategoryDetailResponse,
  updateParkingCategoryDetailResponse,
  getCategoryList,
  getCategoryListResponse,
  getSubCategoryList,
  // getSubCategoryListResponse,
  selectedParkingLocationId,
  rowdata,
  // touched,
  // setFieldValue,
  bookingTypeEnum

}: any) => {
  const pricesForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      // DefaultRate: "0",
      cancellationFee: "0",
      // NumberOfSlotavailable: "20",
      // minimumBookingHours: "1",
      // hourlyRate: "0",
      cancellationDueTime: "0",
      // parkingCategory: "",
      // parkingSubCategory: "",
      fromTimeString: "",
      toTimeString: "",
      bookingType: "",
      // bookingUnits: "0",
      commExtraRate: "0",
      commRate: "0",
      fromTime: "",
      toTime: "",
    },
    validate: (values: any) => {
      const errors: any = {};

      // if (!values.NumberOfSlotavailable) errors['NumberOfSlotavailable'] = 'This field is required';
      // if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.NumberOfSlotavailable))
      //   errors['NumberOfSlotavailable'] = 'Invalid number';
      // if (values.NumberOfSlotavailable < 10) errors['NumberOfSlotavailable'] = 'Capacity must be at least 10';

      // if (!values.minimumBookingHours) errors['minimumBookingHours'] = 'This field is required';
      // if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.minimumBookingHours)) errors['minimumBookingHours'] = 'Invalid number';

      if (values.cancellationFee === 0) errors["cancellationFee"] = "This field is required";
      if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.cancellationFee)) errors["cancellationFee"] = "Invalid number";

      // if (values.DefaultRate === 0) errors['DefaultRate'] = 'This field is required';
      // if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.DefaultRate)) errors['DefaultRate'] = 'Invalid number';

      // if (hidehourlyrate === 4 || hidehourlyrate === 8) {
      //   if (values.hourlyRate === 0) errors['hourlyRate'] = 'This field is required';
      // }

      // if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.hourlyRate)) errors['hourlyRate'] = 'Invalid number';
      if (values.cancellationDueTime == 0 ? false : null) errors["cancellationDueTime"] = "This field is required";
      if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.cancellationDueTime)) errors["cancellationDueTime"] = "Invalid number";
      // if (!values.parkingCategory) errors['parkingCategory'] = 'This field is required';
      // if (!values.parkingSubCategory) errors['parkingSubCategory'] = 'This field is required';
      if (!values.bookingType) errors["bookingType"] = "This field is required";
      if (values.commExtraRate == 0 ? false : null) errors["commExtraRate"] = "This field is required ";
      if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.commExtraRate)) errors["commExtraRate"] = "Invalid number";
      if (values.commRate == 0 ? false : null) errors["commRate"] = "This field is required";
      if (!/^[0-9]+(\.?[0-9]+)?$/.test(values.commRate)) errors["commRate"] = "Invalid number";
      return errors;
    },

    onSubmit: (values: any) => {
      if (mode === false) {
        saveParkingCategoryDetail({
          token: token,
          payload: {
            cancellationDueTime: values.cancellationDueTime,
            cancellationFee: values.cancellationFee,
            // capacity: values.NumberOfSlotavailable,
            // categoryId: values.parkingCategory,
            // dailyLimit: 0,
            // hourlyLimit: 0,
            // dailyRate: values.DefaultRate,
            // hourlyRate: values.hourlyRate ? values.hourlyRate : 0,
            // minimumBookingHours: values.minimumBookingHours,
            parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
            status: true,
            // subCategoryId: values.parkingSubCategory,
            fromTimeString: getUTCTime(fromDates),
            toTimeString: getUTCTime(toDate),
            bookingType: values.bookingType,
            // bookingUnits: parkingNoOfUnit[0].noOfUnit,
            commExtraRate: values.commExtraRate,
            commRate: values.commRate,
          },
        });
      } else {
        updateParkingCategoryDetail({
          token: token,
          payload: {
            cancellationDueTime: values.cancellationDueTime,
            cancellationFee: values.cancellationFee,
            // capacity: values.NumberOfSlotavailable,
            // categoryId: values.parkingCategory,
            // dailyLimit: 0,
            // hourlyLimit: 0,
            // hourlyRate: values.hourlyRate ? values.hourlyRate : 0,
            // dailyRate: values.DefaultRate,
            id: data.id,
            // minimumBookingHours: values.minimumBookingHours,
            parkingLocationId: state.editMode || state.isApprove ? state.id : selectedParkingLocationId,
            status: true,
            // subCategoryId: values.parkingSubCategory,
            fromTimeString: getUTCTime(fromDates),
            toTimeString: getUTCTime(toDate),
            bookingType: values.bookingType,
            // bookingUnits: parkingNoOfUnit[0].noOfUnit,
            commExtraRate: values.commExtraRate,
            commRate: values.commRate,
          },
        });
      }
      handleClose();
      pricesForm.resetForm();
    },
  }) as any;

  useEffect(() => {
    if (saveParkingCategoryDetailResponse.isSuccess) {
      toast.success("Category added successfully");
      getParkingCategoryDetail({
        token: token,
        payload: {
          status: true,
          parkingSpaceLocationId: state.editMode ? state.id : state.isApprove ? state.id : selectedParkingLocationId,
        },
      });
    } else if (saveParkingCategoryDetailResponse.isError) {
      let errorData: any = saveParkingCategoryDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error(msg || "");
    }
  }, [saveParkingCategoryDetailResponse.isSuccess, saveParkingCategoryDetailResponse.isError]);

  useEffect(() => {
    if (updateParkingCategoryDetailResponse.isSuccess) {
      toast.success("Category updated successfully");
      getParkingCategoryDetail({
        token: token,
        payload: {
          status: true,
          parkingSpaceLocationId: state.editMode ? state.id : state.isApprove ? state.id : selectedParkingLocationId,
        },
      });
    } else if (updateParkingCategoryDetailResponse.isError) {
      let errorData: any = updateParkingCategoryDetailResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error(msg || "");
    }
  }, [updateParkingCategoryDetailResponse.isSuccess, updateParkingCategoryDetailResponse.isError]);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    pricesForm.setValues({
      // DefaultRate: "0",
      cancellationFee: "0",
      // NumberOfSlotavailable: "20",
      // minimumBookingHours: "2",
      // hourlyRate: "0",
      cancellationDueTime: "0",
      // parkingCategory: "",
      // parkingSubCategory: "",
      fromTimeString: "",
      toTimeString: "",
      bookingType: "",
      // bookingUnits: "",
      commExtraRate: "0",
      commRate: "0",
    });
    setOpen(false);
  };
  const [mode, setMode] = useState(false) as any;
  const [data, setData] = useState([]) as any;
  const [parkingCategoryData, setparkingCategoryData] = useState([]);
  const [parkingSubCategoryData, setparkingSubCategoryData] = useState([]);
  const [parkingSubCategoryValue, setparkingSubCategoryValue] = useState() as any;
  const [parkingNoOfUnit, setparkingNoOfUnit] = useState() as any;
  const [parkingBookingType, setParkingBookingType] = useState();
  const [hidehourlyrate, setHidehourlyrate] = useState(0) as any;
  const [toDate, setToDate] = useState() as any;
  const [fromDates, setFromDates] = useState(0) as any;
  const [value, setValue] = useState();
  const [parkingCategoryByID, parkingResponce] = useGetParkingCategoryByIdMutation();

  const handleOpen = (value: any) => {
    console.log(value, "valuevalue");
    parkingCategoryByID({
      token: token,
      id: value,
    });
    setOpen(true);
    pricesForm.setValues({
      // DefaultRate: "0",
      cancellationFee: "0",
      // NumberOfSlotavailable: "20",
      // minimumBookingHours: "2",
      // hourlyRate: "0",
      cancellationDueTime: "0",
      // parkingCategory: "",
      // parkingSubCategory: "",
      fromTimeString: "",
      toTimeString: "",
      bookingType: "",
      // bookingUnits: "",
      commExtraRate: "0",
      commRate: "0",
    });
  };

  useEffect(() => {
    if (parkingResponce.isSuccess) {
      pricesForm.setValues({
        // NumberOfSlotavailable: parkingResponce.data.capacity,
        cancellationFee: parkingResponce.data.cancellationFee,
        cancellationDueTime: parkingResponce.data.cancellationDueTime,
        // hourlyRate: parkingResponce.data.hourlyRate,
        // DefaultRate: parkingResponce.data.dailyRate,
        // minimumBookingHours: parkingResponce.data.minimumBookingHours,
        // parkingCategory: parkingResponce.data.categoryId,
        // parkingSubCategory: parkingResponce.data.subCategoryId,
        fromTimeString: fromDates,
        toTimeString: toDate,
        bookingType: parkingResponce.data.bookingType,
        // bookingUnits: parkingResponce.data.bookingUnits,
        commExtraRate: parkingResponce.data.commExtraRate,
        commRate: parkingResponce.data.commRate,
      });
    }
  }, [parkingResponce.isSuccess]);

  useEffect(() => {
    setHidehourlyrate(data.subCategoryId);
    setToDate(data.toTimeString);
    setFromDates(data.fromTimeString);
    let parkingUnit = [
      {
        noOfUnit: data.bookingUnits,
      },
    ];
    setparkingNoOfUnit(parkingUnit);

    // if (data.categoryId !== undefined) {
    //   getSubCategoryList({
    //     token: token,
    //     categoryId: data.categoryId,
    //   });
    // }
  }, [data]);

  const styleActiveModel = {
    position: "absolute" as "absolute",
    top: "52%",
    left: "47%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    p: "40px",
    px: "40px",
  };

  useEffect(() => {
    getCategoryList({
      token: token,
    });
  }, [getCategoryList]);

  useEffect(() => {
    if (getCategoryListResponse) {
      setparkingCategoryData(getCategoryListResponse.data);
    }
  }, [getCategoryListResponse]);

  const handleSubCategory = (event: any) => {
    getSubCategoryList({
      token: token,
      categoryId: event.target.value,
    });
  };

  const handletextfield = (event: any) => {
    setHidehourlyrate(event.target.value);
    setParkingBookingType(event.target.value);
  };

  const handleCategory = (event: any) => {
    setparkingSubCategoryValue(event.target.value);
    const selectedSubCategory = parkingSubCategoryData.filter((item: any) => {
      return item.id === event.target.value;
    });
    setparkingNoOfUnit(selectedSubCategory);
  };

  const formatTime = (date: number | Date) => {
    return date ? format(date, 'HH:mm') : null;
  };

  // useEffect(() => {
  //   if (getSubCategoryListResponse) {
  //     setparkingSubCategoryData(getSubCategoryListResponse.data);
  //   }
  // }, [getSubCategoryListResponse]);

  return (
    <div>
      <Box>
        <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
          <Box>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Price Details</p>
          </Box>
          <Box>
            <Stack direction="row" alignItems="center" justifyContent="end" marginBottom={"25px"}>
              <Button
                variant="contained"
                onClick={() => {
                  setMode(false);
                  setOpen(true);
                }}
                startIcon={<Iconify icon="eva:plus-fill" sx={undefined} />}
                style={{ color: "white", backgroundColor: "#E23744" }}
                size="large">
                Add
              </Button>
            </Stack>

            <TableContainer>
              <Table size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow style={{ fontSize: "50px", fontWeight: "bold", color: "black" }}>
                    {/* <TableCell align="left">Category </TableCell> */}
                    {/* <TableCell align="left">Sub Category </TableCell> */}
                    {/* <TableCell align="left">No. of Slots</TableCell> */}
                    <TableCell align="left">Booking Type</TableCell>
                    <TableCell align="left">Base Charges</TableCell>
                    <TableCell align="left">Extra Charges Per KM</TableCell>
                    <TableCell align="left">Canc. Fee</TableCell>
                    <TableCell align="left">Canc. Due Time</TableCell>
                    {/* <TableCell align="left">Private Vehicle Extra Charges</TableCell>
                    <TableCell align="left">Private Vehicle Fixed Fee</TableCell>
                    <TableCell align="left">Min. Booking Hrs</TableCell>*/}
                    <TableCell align="left">Operational Hours</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {rowdata &&
                    rowdata.map((row: any, index: any) => (
                      <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }} key={index}>
                        {/* <TableCell
                          align="center"
                          onClick={() => {
                            setData(row);
                            setMode(true);

                            handleOpen(row.id);
                          }}
                          style={{ cursor: 'pointer', color: 'blue' }}
                        >
                          {row.categoryName}
                        </TableCell> */}
                        {/* <TableCell align="center">
                          {row.subCategoryName + (row.bookingType == null ? '' : '-' + row.bookingType)}
                        </TableCell>
                        <TableCell align="center">{row.capacity}</TableCell> */}
                        <TableCell align="center" onClick={() => {
                          setData(row);
                          setMode(true);

                          handleOpen(row.id);
                        }}
                          style={{ cursor: 'pointer', color: 'blue' }}>{row.bookingType}</TableCell>
                        <TableCell align="center">{row.commRate}</TableCell>
                        <TableCell align="center">{row.commExtraRate}</TableCell>
                        <TableCell align="center">{row.cancellationFee}</TableCell>
                        <TableCell align="center">{row.cancellationDueTime}</TableCell>
                        {/* <TableCell align="center">{row.hourlyRate}</TableCell> */}
                        {/* <TableCell align="center">{row.dailyRate}</TableCell> */}
                        {/* <TableCell align="center">{row.minimumBookingHours}</TableCell> */}
                        <TableCell align="center">{getISTTime(row.fromTimeString) + " - " + getISTTime(row.toTimeString)}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              {rowdata.length == 0 ? (
                <Box>
                  <Typography gutterBottom align="center" variant="subtitle1">
                    No record found!!!{" "}
                  </Typography>
                  <Typography gutterBottom align="center" variant="subtitle1" style={{ color: "red" }}>
                    Please add atleast one record in order to proceed!
                  </Typography>
                </Box>
              ) : (
                ""
              )}
            </TableContainer>

            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <form onSubmit={pricesForm.handleSubmit}>
                {parkingResponce.isLoading ? <Loading /> : null}
                <Box sx={styleActiveModel} style={{ overflowY: "auto", height: "70%" }}>
                  <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <h1>{mode == true ? "Edit Details" : "Add More Details"}</h1>
                  </Stack>

                  <Box border={1} borderRadius={2} borderColor={"white"} style={{ backgroundColor: "white" }}>
                    {/* <Box display={'flex'} marginTop={'25px'}>
                      <Box>
                        <p style={{ marginTop: '10px' }}>Category</p>

                        <Select
                          id="parkingCategory"
                          name="parkingCategory"
                          style={{
                            width: '225px',
                          }}
                          value={pricesForm.values.parkingCategory}
                          placeholder="Select type"
                          onChange={pricesForm.handleChange}
                          onBlur={handleSubCategory}
                          displayEmpty
                          defaultValue={'0'}
                        >
                          <MenuItem disabled value="0">
                            Select Option
                          </MenuItem>
                          {parkingCategoryData &&
                            parkingCategoryData.map((parkingCategory: any) => (
                              <MenuItem value={parkingCategory.id} key={parkingCategory.id}>
                                {parkingCategory.categoryName}
                              </MenuItem>
                            ))}
                        </Select>
                        {pricesForm.errors.parkingCategory && (
                          <div style={{ color: 'red' }}>{pricesForm.errors.parkingCategory}</div>
                        )}
                      </Box>

                      <Box marginLeft={'50px'}>
                        <p style={{ marginTop: '10px' }}>Sub-category</p>
                        <Select
                          name="parkingSubCategory"
                          id="parkingSubCategory"
                          value={pricesForm.values.parkingSubCategory}
                          style={{
                            width: '222px',
                          }}
                          onChange={pricesForm.handleChange}
                          onBlur={(e: any) => {
                            handleCategory(e);
                            setparkingSubCategoryValue(e.target.value);
                          }}
                          displayEmpty
                          defaultValue={'0'}
                        >
                          <MenuItem disabled value="">
                            Select Option
                          </MenuItem>
                          {parkingSubCategoryData &&
                            parkingSubCategoryData.map((parkingSubCategoryDatas: any) => (
                              <MenuItem key={parkingSubCategoryDatas.id} value={parkingSubCategoryDatas.id}>
                                {parkingSubCategoryDatas.subCategoryName}
                              </MenuItem>
                            ))}
                        </Select>
                        {pricesForm.errors.parkingSubCategory && (
                          <div style={{ color: 'red' }}>{pricesForm.errors.parkingSubCategory}</div>
                        )}
                      </Box>
                    </Box> */}

                    <Box display={"flex"} marginTop={"10px"}>
                      <Box width={"100%"}>
                        <p style={{ marginTop: "2px" }}>Booking Type</p>
                        <Select
                          fullWidth
                          name="bookingType"
                          id="bookingType"
                          value={pricesForm.values.bookingType}
                          onChange={pricesForm.handleChange}
                          onBlur={handletextfield}
                          displayEmpty
                          defaultValue={"0"}>
                          <MenuItem disabled value="">
                            Booking Type
                          </MenuItem>
                          {bookingTypeEnum &&
                            bookingTypeEnum.map((bookingType: any) => (
                              <MenuItem key={bookingType?.code} value={bookingType?.code}>
                                {bookingType?.code}
                              </MenuItem>
                            ))}
                        </Select>
                        {pricesForm.errors.bookingType && <div style={{ color: "red" }}>{pricesForm.errors.bookingType}</div>}
                      </Box>
                      {/* <Box marginLeft={'60px'}>
                        <p style={{ marginTop: '2px' }}>No. of Slots</p>
                        <Stack direction="row" alignItems="center">
                          <TextField
                            id="Number-Of-Slot-available"
                            value={pricesForm.values.NumberOfSlotavailable}
                            onChange={pricesForm.handleChange}
                            onBlur={pricesForm.handleBlur}
                            name="NumberOfSlotavailable"
                          />
                        </Stack>
                        {pricesForm.errors.NumberOfSlotavailable && (
                          <div style={{ color: 'red' }}>{pricesForm.errors.NumberOfSlotavailable}</div>
                        )}
                      </Box> */}
                    </Box>
                    {/* <Box display={'flex'} marginTop={'25px'}>
                      <Box>
                        <Stack direction="row" style={{ width: '92%' }} alignItems="center">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Box>
                              <TimePicker
                                label="From Time"
                                value={fromDates}
                                onChange={(newValue) => {
                                  setFromDates(newValue);
                                  handleChange({ target: { name: 'fromTimeString', value: newValue?.toString() } });
                                }}
                                renderInput={(params) => <TextField sx={{ marginRight: 5 }} {...params} />}
                              />
                              {fromDates == null && <div style={{ color: 'red' }}>This field is required</div>}
                            </Box>
                            <Box>
                              <TimePicker
                                label="To Time"
                                value={toDate}
                                onChange={(newValue) => {
                                  setToDate(newValue);
                                  handleChange({ target: { name: 'toTimeString', value: newValue?.toString() } });
                                }}
                                renderInput={(params) => <TextField {...params} />}
                              />
                              {toDate == null && <div style={{ color: 'red' }}>This field is required</div>}
                            </Box>
                          </LocalizationProvider>
                        </Stack>
                      </Box>
                    </Box> */}
                    {/* <Box display={'flex'} marginTop={'25px'}>
                      <Box>
                        <Stack direction="row" alignItems="center">
                          <TextField
                            id="hourly-rate"
                            label="Private Vehicle Extra Charges"
                            value={pricesForm.values.hourlyRate}
                            onChange={pricesForm.handleChange}
                            onBlur={pricesForm.handleBlur}
                            name="hourlyRate"
                          />
                        </Stack>
                        {pricesForm.errors.hourlyRate && (
                          <div style={{ color: 'red' }}>{pricesForm.errors.hourlyRate}</div>
                        )}
                      </Box>
                      <Box marginLeft={'50px'}>
                        <Stack direction="row" alignItems="center">
                          <TextField
                            id="Default-Rate"
                            label="Private Vehicle Fixed Fee"
                            value={pricesForm.values.DefaultRate}
                            onChange={pricesForm.handleChange}
                            onBlur={pricesForm.handleBlur}
                            name="DefaultRate"
                          />
                        </Stack>
                        {pricesForm.errors.DefaultRate && (
                          <div style={{ color: 'red' }}>{pricesForm.errors.DefaultRate}</div>
                        )}
                      </Box>
                    </Box> */}
                    <Box display={"flex"} marginTop={"25px"}>
                      <Box marginRight={"50px"}>
                        <Stack direction="row" alignItems="center">
                          <TextField
                            id="Commercial-Rate"
                            label="Base Charges"
                            value={pricesForm.values.commRate}
                            onChange={pricesForm.handleChange}
                            onBlur={pricesForm.handleBlur}
                            name="commRate"
                          />
                        </Stack>
                        {pricesForm.errors.commRate && <div style={{ color: "red" }}>{pricesForm.errors.commRate}</div>}
                      </Box>
                      <Box>
                        <Stack direction="row" alignItems="center">
                          <TextField
                            id="Commercial-Extra-Rate"
                            label="Extra Charges Per KM"
                            value={pricesForm.values.commExtraRate}
                            onChange={pricesForm.handleChange}
                            onBlur={pricesForm.handleBlur}
                            name="commExtraRate"
                          />
                        </Stack>
                        {pricesForm.errors.commExtraRate && <div style={{ color: "red" }}>{pricesForm.errors.commExtraRate}</div>}
                      </Box>
                    </Box>
                    <Box display={"flex"} marginTop={"25px"}>
                      <Box marginRight={2} flex={1}>
                        <TextField
                          id="cancellation-due-time"
                          label="Cancellation Due Time (hrs)"
                          value={pricesForm.values.cancellationDueTime}
                          onChange={pricesForm.handleChange}
                          onBlur={pricesForm.handleBlur}
                          name="cancellationDueTime"
                          type="number"
                        />
                        {pricesForm.errors.cancellationDueTime && <div style={{ color: "red" }}>{pricesForm.errors.cancellationDueTime}</div>}
                      </Box>

                      <Box flex={1}>
                        <Stack direction="row" alignItems="center">
                          <TextField
                            id="cancellation-Fee"
                            label={"Cancellation Fee"}
                            value={pricesForm.values.cancellationFee}
                            onChange={pricesForm.handleChange}
                            onBlur={pricesForm.handleBlur}
                            name="cancellationFee"
                          />
                        </Stack>
                        {pricesForm.errors.cancellationFee && <div style={{ color: "red" }}>{pricesForm.errors.cancellationFee}</div>}
                      </Box>
                    </Box>

                    <Box display={"flex"} marginTop={"25px"}>
                      <Stack direction="row" style={{ width: '92%' }} alignItems="center">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <Box>
                            <TimePicker
                              label="From Time"
                              value={fromDates}
                              onChange={(newValue) => {
                                setFromDates(newValue);
                                handleChange({
                                  target: {
                                    name: 'fromTimeString',
                                    value: formatTime(newValue), // Format the time
                                  },
                                });
                              }}
                              renderInput={(params) => <TextField sx={{ marginRight: 5 }} {...params} />}
                            />
                            {fromDates == null && <div style={{ color: 'red' }}>This field is required</div>}
                          </Box>
                          <Box>
                            <TimePicker
                              label="To Time"
                              value={toDate}
                              onChange={(newValue) => {
                                setToDate(newValue);
                                handleChange({
                                  target: {
                                    name: 'toTimeString',
                                    value: formatTime(newValue), // Format the time
                                  },
                                });
                              }}
                              renderInput={(params) => <TextField {...params} />}
                            />
                            {toDate == null && <div style={{ color: 'red' }}>This field is required</div>}
                          </Box>
                        </LocalizationProvider>
                      </Stack>
                    </Box>

                    {/* <Box display={'flex'} marginTop={'25px'}>
                      <Box>
                        <Stack direction="row" alignItems="center">
                          <TextField
                            id="minimum-booking-hrs"
                            label="Minimum Booking (hrs)"
                            value={pricesForm.values.minimumBookingHours}
                            onChange={pricesForm.handleChange}
                            onBlur={pricesForm.handleBlur}
                            name="minimumBookingHours"
                          />
                        </Stack>
                        {pricesForm.errors.minimumBookingHours && (
                          <div style={{ color: 'red' }}>{pricesForm.errors.minimumBookingHours}</div>
                        )}
                      </Box>
                    </Box> */}
                    <div style={{ display: "flex", marginTop: "30px", justifyContent: "end" }}>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          handleClose();
                        }}
                        size="medium">
                        Cancel
                      </Button>
                      <Button
                        disabled={pricesForm.errors?.length > 0 ? true : false}
                        style={{ color: "white", backgroundColor: "#E23744", marginLeft: "10px" }}
                        variant="contained"
                        size="medium"
                        type="submit"
                        onClick={() => { }}>
                        Save
                      </Button>
                    </div>
                  </Box>
                </Box>
              </form>
            </Modal>
          </Box>
          <Box>
            <Box display={'flex'} marginTop={'25px'} width={'100%'}>
              {/* <Box marginLeft={'60px'}>
                <Typography variant="h6" marginTop={2} gutterBottom component="div">
                  Category
                </Typography>

                <Select
                  id="parkingCategory"
                  name="parkingCategory"
                  style={{
                    width: '235px',
                  }}
                  value={values.parkingCategory}
                  placeholder="Select option"
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={'0'}
                >
                  <MenuItem disabled value="0">
                    Select Category
                  </MenuItem>
                  {parkingCategory &&
                    parkingCategory.map((item: any) => (
                      <MenuItem value={item.code} key={item.code}>
                        {item.displayValue}
                      </MenuItem>
                    ))}
                </Select>
                {errors.parkingCategory && <div style={{ color: 'red' }}>{errors.parkingCategory}</div>}
              </Box> */}
            </Box>
            {state.isAdmin == false ? (
              <div style={{ marginTop: "10px" }}>
                <Typography variant="h6" marginTop={2} gutterBottom component="div">
                  Taxes
                </Typography>
                <Box display={"flex"} marginTop={2}>
                  <Box flex={1}>
                    <Stack direction="row" alignItems="center">
                      <TextField
                        id="CGST"
                        label={"CGST"}
                        value={values.CGST}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="CGST"

                        type="number"
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                          inputMode: "numeric",
                        }}
                      />
                    </Stack>
                  </Box>
                  <Box marginLeft={"20px"} flex={1}>
                    <Stack direction="row" alignItems="center">
                      <TextField
                        id="SGST"
                        label={"SGST"}
                        value={values.SGST}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="SGST"
                        type="number"
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                          inputMode: "numeric",
                        }}

                      />
                    </Stack>
                  </Box>
                  {/* <Box marginLeft={"20px"} flex={1}>
                    <Stack direction="row" alignItems="center">
                      <TextField
                        id="fixedFee"
                        label={"Fixed Fee"}
                        value={values.fixedFee}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="fixedFee"
                        type="number"
                        InputProps={{
                          endAdornment: <InputAdornment position="end">₹</InputAdornment>,
                          inputMode: "numeric",
                        }}
                        
                      />
                    </Stack>
                  </Box> */}
                </Box>
                <Box>
                  <div style={{ marginTop: "10px" }}>
                    <Typography variant="h6" gutterBottom component="div">
                      Service Type
                    </Typography>
                    <Grid container spacing={0} rowSpacing={1}>
                      {parkingManagementData &&
                        parkingManagementData.map((parking: any) => (
                          <Grid item xs={6} key={parking?.id} >
                            <FormGroup>
                              <FormControlLabel
                                key={`${parking?.id + "-" + getUniqueKey() + "uniqueKeyServiceType"}`}
                                control={
                                  <Checkbox
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="parkingTypeId"
                                    checked={values.parkingTypeId.includes((parking?.id).toString())}
                                    value={(parking?.id)}
                                    key={`${parking?.id + "-" + getUniqueKey() + "uniqueKeyService"}`}
                                    onClick={() => console.log("forms value:   ", values)}
                                  />
                                }
                                label={parking?.typeName}
                              />
                            </FormGroup>
                          </Grid>
                        ))}
                    </Grid>
                  </div>
                </Box>
              </div>
            ) : (
              <div style={{ marginTop: "10px" }}>
                <Typography variant="h6" marginTop={2} gutterBottom component="div">
                  Taxes
                </Typography>
                <Box display={"flex"} marginTop={"25px"}>
                  <Box>
                    <Stack direction="row" alignItems="center">
                      <TextField
                        id="CGST"
                        label={"CGST"}
                        value={values.CGST}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="CGST"
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                      />
                    </Stack>
                    {errors.CGST && <div style={{ color: "red" }}>{errors.CGST}</div>}
                  </Box>
                  <Box marginLeft={"60px"}>
                    <Stack direction="row" alignItems="center">
                      <TextField
                        id="SGST"
                        label={"SGST"}
                        value={values.SGST}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="SGST"
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                          inputMode: "numeric",
                        }}
                      />
                    </Stack>
                    {errors.SGST && <div style={{ color: "red" }}>{errors.SGST}</div>}
                  </Box>
                </Box>
                {/* <Box marginTop={"25px"}>
                  <Stack direction="row" alignItems="start">
                    <TextField
                      id="fixedFee"
                      label={"Fixed Fee"}
                      value={values.fixedFee}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="fixedFee"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">₹</InputAdornment>,
                        inputMode: "numeric",
                      }}
                    />
                  </Stack>
                  {errors.fixedFee && <div style={{ color: "red" }}>{errors.fixedFee}</div>}
                </Box> */}
                <div style={{ marginTop: "10px" }}>
                  <Typography variant="h6" gutterBottom component="div">
                    Service Type
                  </Typography>
                  <Grid container spacing={0} rowSpacing={1}>
                    {parkingManagementData &&
                      parkingManagementData.map((parking: any) => (
                        <Grid item xs={6} key={parking?.id}>
                          <FormGroup>
                            <FormControlLabel
                              key={`${parking?.id + "-" + getUniqueKey() + "uniqueKeyServiceType"}`}
                              control={
                                <Checkbox
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="parkingTypeId"
                                  checked={values.parkingTypeId.includes((parking?.id).toString())}
                                  value={parking?.id}
                                  key={`${parking?.id + "-" + getUniqueKey() + "uniqueKeyService"}`}
                                />
                              }
                              label={parking?.typeName}
                            />
                          </FormGroup>
                        </Grid>
                      ))}
                  </Grid>
                </div>
              </div>

            )}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

// const Overview = ({
//   values,
//   setFieldValue,
//   handleChange,
//   handleBlur,
//   touched,
//   content,
//   setContent,
//   editor,
//   contentOne,
//   setContentOne,
//   contentTwo,
//   setContentTwo,
//   contentThree,
//   setContentThree,
//   formValues,
//   errors,
//   isPinRequired,
//   setIsPinRequired,
//   state,
//   config,
// }: any) => {
//   return (
//     <div>
//       <Box>
//         <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
//           <Box>
//             <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Additional Details</p>
//           </Box>
//           <Box style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
//             <Box marginTop={2} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
//               <Checkbox
//                 name="isPinRequired"
//                 checked={values.isPinRequired}
//                 onChange={(e: any) => {
//                   setFieldValue("isPinRequired", !values.isPinRequired);
//                   setIsPinRequired(e.target.checked);
//                 }}
//               />
//               <Typography variant="h6" component="div">
//                 Is PIN required?
//               </Typography>
//             </Box>
//             {isPinRequired && (
//               <Box width="50%" marginTop={"25px"} marginLeft={"20px"}>
//                 <TextField
//                   fullWidth
//                   id="parkingPin"
//                   autoComplete="Pin"
//                   type="number"
//                   name="parkingPin"
//                   label={"Pin"}
//                   value={values.parkingPin}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 />
//                 {errors.parkingPin && <div style={{ color: "red" }}>{errors.parkingPin}</div>}
//               </Box>
//             )}
//           </Box>
//           <Box sx={{ marginTop: "25px" }}>
//             <Box width="70%" marginTop={"25px"}>
//               <TextField
//                 fullWidth
//                 id="Listing-Name"
//                 autoComplete="Listing Name"
//                 type="text"
//                 name="ListingName"
//                 label={"Listing Name"}
//                 value={values.ListingName}
//                 onChange={handleChange}
//                 onBlur={handleBlur}
//               />
//               {errors.ListingName && <div style={{ color: "red" }}>{errors.ListingName}</div>}
//             </Box>
//             <Box>
//               <Box style={{ width: "100%", marginTop: "20px" }}>
//                 <Typography variant="h5" marginTop={2} gutterBottom component="div">
//                   Listing Description
//                 </Typography>
//                 <EditorToolbar toolbarId={"t1"} />
//                 <ReactQuill
//                   theme="snow"
//                   onChange={(newContent: any) => setFieldValue("ListingDescription", newContent)}
//                   value={values.ListingDescription}
//                   modules={modules("t1")}
//                   formats={formats}
//                 />
//                 {errors.ListingDescription && <div style={{ color: "red" }}>{errors.ListingDescription}</div>}
//               </Box>

//               <Box style={{ width: "100%", marginTop: "20px" }}>
//                 <Typography variant="h5" marginTop={2} gutterBottom component="div">
//                   Listing Instruction
//                 </Typography>
//                 <EditorToolbar toolbarId={"t2"} />
//                 <ReactQuill
//                   theme="snow"
//                   onChange={(newContent: any) => setFieldValue("ListingInstruction", newContent)}
//                   value={values.ListingInstruction}
//                   modules={modules("t2")}
//                   formats={formats}
//                 />
//                 {errors.ListingInstruction && <div style={{ color: "red" }}>{errors.ListingInstruction}</div>}
//               </Box>

//               <Box style={{ width: "100%", marginTop: "20px" }}>
//                 <Typography variant="h5" marginTop={2} gutterBottom component="div">
//                   Cancellation Policy
//                 </Typography>
//                 <EditorToolbar toolbarId={"t3"} />
//                 <ReactQuill
//                   theme="snow"
//                   onChange={(newContent: any) => setFieldValue("CancellationPolicy", newContent)}
//                   value={values.CancellationPolicy}
//                   modules={modules("t3")}
//                   formats={formats}
//                 />
//                 {errors.CancellationPolicy && <div style={{ color: "red" }}>{errors.CancellationPolicy}</div>}
//               </Box>

//               <Box style={{ width: "100%", marginTop: "20px" }}>
//                 <Typography variant="h5" marginTop={2} gutterBottom component="div">
//                   Special instructions for email confirmation
//                 </Typography>
//                 <EditorToolbar toolbarId={"t4"} />
//                 <ReactQuill
//                   theme="snow"
//                   onChange={(newContent: any) => setFieldValue("Specialinstructionsforemailconfirmation", newContent)}
//                   value={values.Specialinstructionsforemailconfirmation}
//                   modules={modules("t4")}
//                   formats={formats}
//                 />
//                 {errors.Specialinstructionsforemailconfirmation && <div style={{ color: "red" }}>{errors.Specialinstructionsforemailconfirmation}</div>}
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </div>
//   );
// };

const Photo = ({ cityImage, isImgUrl, setIsImgUrl, uploadedPermitImage, setCityImage, permitImage, setPermitImage, uploadImages, uploadedImage, deleteImage, values, isPermitImageUploaded }: any) => {
  return (
    <div>
      <Box>
        <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
          <Box>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Upload Photos</p>
          </Box>
          <Box>
            <p style={{ fontWeight: "bold", color: "#E23744", fontSize: "16px" }}>Note: Image dimension should be atleast 600 X 400</p>
            <Box className="page" display={'flex'}>
              <div
                className="container"
                style={{
                  width: "167px",
                  borderRadius: "10px",
                }}>
                <div
                  className="img-holder"
                  style={{
                    margin: "autoComplete",
                    width: "150px",
                    height: "150px",
                    borderRadius: "10px",
                    marginTop: "1rem",

                    background: "lightgray",
                  }}>
                  {cityImage && (
                    <img
                      src={isImgUrl ? cityImage : require("../../../assets/static/mock-images/avatars/avatar_1.jpg")}
                      alt=""
                      id="img"
                      className="img"
                      style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius: "10px" }}
                    />
                  )}
                </div>
                <input
                  type="file"
                  accept="image/*"
                  name="image-upload"
                  id="input"
                  onChange={(event: any) => {
                    var reader = new FileReader();

                    //Read the contents of Image File.
                    reader.readAsDataURL(event.target.files[0]);
                    reader.onload = function (e) {
                      //Initiate the JavaScript Image object.
                      var image: any = new Image();

                      //Set the Base64 string return from FileReader as source.
                      image.src = e.target?.result;

                      //Validate the File Height and Width.
                      image.onload = function () {
                        var height = image.height;
                        var width = image.width;
                        if (height < 400 || width < 600) {
                          toast.success("Image dimension should be within 600 X 400");
                          return false;
                        } else {
                          if (isImgUrl) {
                            setIsImgUrl(false);
                          }

                          setCityImage(event.target.files[0]);
                        }
                      };
                    };
                  }}
                  style={{ display: "none" }}
                />
                <div
                  className="label"
                  style={{
                    width: "100%",
                    marginTop: "1rem",
                    display: "flex",
                    //  justifyContent: 'center'
                    marginLeft: "20px",
                  }}>
                  <label
                    className="image-upload"
                    htmlFor="input"
                    style={{
                      width: "110px",
                      height: "35px",
                      color: "white",
                      backgroundColor: "#E23744",
                      textAlign: "center",
                      cursor: " pointer",
                      borderRadius: "10px",
                      padding: "5px",
                    }}>
                    Select Image
                  </label>
                </div>
              </div>

              {(values.permitType && !isPermitImageUploaded) && <div
                className="container"
                style={{
                  width: "167px",
                  borderRadius: "10px",
                }}>
                <div
                  className="img-holder"
                  style={{
                    margin: "autoComplete",
                    width: "150px",
                    height: "150px",
                    borderRadius: "10px",
                    marginTop: "1rem",

                    background: "lightgray",
                  }}>
                  {permitImage && (
                    <img
                      src={isImgUrl ? permitImage : require("../../../assets/static/mock-images/avatars/avatar_1.jpg")}
                      alt=""
                      id="img"
                      className="img"
                      style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius: "10px" }}
                    />
                  )}
                </div>
                <input
                  type="file"
                  accept="image/*"
                  name="image-upload"
                  id="input-permit"
                  onChange={(event: any) => {
                    var reader = new FileReader();

                    //Read the contents of Image File.
                    reader.readAsDataURL(event.target.files[0]);
                    reader.onload = function (e) {
                      //Initiate the JavaScript Image object.
                      var image: any = new Image();

                      //Set the Base64 string return from FileReader as source.
                      image.src = e.target?.result;

                      //Validate the File Height and Width.
                      image.onload = function () {
                        var height = image.height;
                        var width = image.width;
                        if (height < 400 || width < 600) {
                          toast.success("Image dimension should be within 600 X 400");
                          return false;
                        } else {
                          if (isImgUrl) {
                            setIsImgUrl(false);
                          }

                          setPermitImage(event.target.files[0]);
                        }
                      };
                    };
                  }}
                  style={{ display: "none" }}
                />
                <div
                  className="label"
                  style={{
                    width: "100%",
                    marginTop: "1rem",
                    display: "flex",
                    //  justifyContent: 'center'
                    marginLeft: "20px",
                  }}>
                  <label
                    className="image-upload"
                    htmlFor="input-permit"
                    style={{
                      width: "110px",
                      height: "35px",
                      color: "white",
                      backgroundColor: "#E23744",
                      textAlign: "center",
                      cursor: " pointer",
                      borderRadius: "10px",
                      padding: "5px",
                    }}>
                    Select Permit
                  </label>
                </div>
              </div>}

            </Box>
          </Box>
          <p style={{ fontWeight: "bold", color: "gray", fontSize: "20px", marginTop: "25px" }}>Photos</p>
          <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
            {[...Array(5)].map((item: any, index: any) => (
              <div key={index}>
                <div
                  className="img-holder"
                  style={{
                    margin: "autoComplete",
                    width: "150px",
                    height: "150px",
                    borderRadius: "10px",
                    marginTop: "1rem",
                    background: "lightgray",
                    zIndex: "1",
                    position: "relative",
                  }}
                  key={index}>
                  <img
                    src={
                      uploadedImage && uploadedImage.length > index
                        ? uploadedImage[index].filePreSignedUrl
                        : require("../../../assets/static/mock-images/avatars/avatar_1.jpg")
                    }
                    alt=""
                    id={index}
                    key={index}
                    className="img"
                    style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius: "10px" }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "10px",
                      fontSize: "27px",
                      backgroundColor: "white",
                      width: "26px",
                      height: "32px",
                      borderRadius: "50%",
                    }}
                    onClick={() => {
                      deleteImage(uploadedImage[index].id);
                    }}>
                    <CloseIcon />
                  </div>
                </div>
              </div>
            ))}
          </div>
          {(values.permitType) &&
            <>
              <p style={{ fontWeight: "bold", color: "gray", fontSize: "20px", marginTop: "25px" }}> Permit Photos</p>
              <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                {[...Array(1)].map((item: any, index: any) => (
                  <div key={index}>
                    <div
                      className="img-holder"
                      style={{
                        margin: "autoComplete",
                        width: "150px",
                        height: "150px",
                        borderRadius: "10px",
                        marginTop: "1rem",
                        background: "lightgray",
                        zIndex: "1",
                        position: "relative",
                      }}
                      key={index}>
                      <img
                        src={
                          uploadedPermitImage && uploadedPermitImage.length > index
                            ? uploadedPermitImage[index].filePreSignedUrl
                            : require("../../../assets/static/mock-images/avatars/avatar_1.jpg")
                        }
                        alt=""
                        id={index}
                        key={index}
                        className="img"
                        style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius: "10px" }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "10px",
                          fontSize: "27px",
                          backgroundColor: "white",
                          width: "26px",
                          height: "32px",
                          borderRadius: "50%",
                        }}
                        onClick={() => {
                          deleteImage(uploadedPermitImage[index].id);
                        }}>
                        <CloseIcon />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          }
        </Box>
      </Box>
    </div>
  );
};

const Contact = ({ values, errors, handleChange, handleBlur, touched, findParkingSpaceLocationByIdResponse, state }: any) => {
  return (
    <div>
      <Box>
        <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
          <Box>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Contact Details</p>
          </Box>
          <Box display={"flex"}>
            <Box style={{ marginTop: "25px" }}>
              <TextField id="firstName " label={"First Name "} value={values.firstName} onChange={handleChange} onBlur={handleBlur} name="firstName" />
              {errors.firstName && <div style={{ color: "red" }}>{errors.firstName}</div>}
            </Box>

            <Box style={{ marginTop: "25px", marginLeft: "60px" }}>
              <TextField id="lastName" label={"Last Name"} value={values.lastName} onChange={handleChange} onBlur={handleBlur} name="lastName" />
              {errors.lastName && <div style={{ color: "red" }}>{errors.lastName}</div>}
            </Box>
          </Box>
          <Box display={"flex"}>
            <Box style={{ marginTop: "25px" }}>
              <TextField
                id="phoneNumber"
                label={"Phone Number"}
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                name="phoneNumber"
                disabled={state?.parkingSpace?.currentStatus === "active" && state?.isAdmin === false ? true : false}
              />
              {errors.phoneNumber && <div style={{ color: "red" }}>{errors.phoneNumber}</div>}
            </Box>

            <Box style={{ marginTop: "25px", marginLeft: "60px" }}>
              <TextField
                id="Email"
                label={"Email"}
                value={values.Email}
                onChange={handleChange}
                onBlur={handleBlur}
                name="Email"
                disabled={state?.parkingSpace?.currentStatus === "active" && state?.isAdmin === false ? true : false}
              />
              {errors.Email && <div style={{ color: "red" }}>{errors.Email}</div>}
            </Box>
          </Box>
          <Box>
            <p style={{ fontWeight: "bold", color: "gray", fontSize: "20px", marginTop: "25px" }}>Business Details</p>
            <Box style={{ marginTop: "25px" }}>
              <TextField
                fullWidth
                id="NameOfParentCompany"
                label={"Parent Company Name"}
                value={values.NameOfParentCompany}
                onChange={handleChange}
                onBlur={handleBlur}
                name="NameOfParentCompany"
                disabled={state?.parkingSpace?.currentStatus === "active" && state.isAdmin === false ? true : false}
              />
            </Box>
            <Box display={"flex"}>
              <Box style={{ marginTop: "25px" }}>
                <TextField
                  id="GSTno"
                  label={"GST No."}
                  value={values.GSTno.toUpperCase()}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="GSTno"
                  disabled={state?.parkingSpace?.currentStatus === "active" && state.isAdmin === false ? true : false}
                />
                {errors.GSTno && <div style={{ color: "red" }}>{errors.GSTno}</div>}
              </Box>
              <Box style={{ marginTop: "25px", marginLeft: "60px" }}>
                <TextField
                  id="PANno"
                  value={values.PANno.toUpperCase()}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="PANno"
                  label={"PAN/TAN Card No."}
                  disabled={state?.parkingSpace?.currentStatus === "active" && state?.isAdmin === false ? true : false}
                />
                {errors.PANno && <div style={{ color: "red" }}>{errors.PANno}</div>}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

const BlackoutDate = ({
  selected,
  order,
  orderBy,
  filterName,
  handleRequestSort,
  blackoutData,
  handleSelectAllClick,
  filteredUsers,
  isUserNotFound,
  blackoutForm,
  saveBlackoutDay,
  updateBlackoutDay,
}: any) => {
  return (
    <div>
      <Box>
        <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
          <Box>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Blackout Date</p>
          </Box>

          <Formik enableReinitialize={true} initialValues={blackoutForm} onSubmit={saveBlackoutDay} validationSchema={blackoutDateSchema}>
            {({ values, errors, touched, handleChange, handleBlur, setFieldValue, handleSubmit }) => (
              <Container
                sx={{
                  paddingTop: "4px",
                  paddingBottom: "4px",
                }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={"25px"}>
                  <Box>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Date"
                        value={values.date}
                        minDate={new Date()}
                        onChange={(event: any) => {
                          setFieldValue("date", event);
                        }}
                        renderInput={(params) => (
                          <TextField
                            id="date"
                            name="date"
                            style={{
                              width: "250px",
                              borderColor: "blue",
                            }}
                            onBlur={handleBlur}
                            onChange={(event: any) => {
                              setFieldValue("date", event.target.value);
                            }}
                            {...params}
                            error={Boolean(touched.date && errors.date)}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Box>
                  <Box alignItems={"center"}>
                    <Box width="100%">
                      <Stack direction="column" alignItems="self-start">
                        <TextField
                          sx={{ width: "250px" }}
                          placeholder="Event description"
                          variant="outlined"
                          id={"outlined-multiline-static"}
                          name={"description"}
                          value={values.description}
                          multiline
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(touched.description && errors.description)}
                        />
                      </Stack>
                    </Box>
                  </Box>
                  <Stack direction="row" justifyContent={"center"} alignItems={"center"}>
                    <Button
                      style={{ color: "white", backgroundColor: "#E23744" }}
                      onClick={() => {
                        handleSubmit();
                      }}
                      variant="contained"
                      sx={{ padding: "8px", width: "100px" }}>
                      ADD
                    </Button>
                  </Stack>
                </Stack>
              </Container>
            )}
          </Formik>
          <Card>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={blackoutData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row: any) => {
                      const { id, name, date, description, status } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow hover key={id.toString()} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                          <TableCell align="left">
                            <Typography>{format(new Date(date), "MM/dd/yyyy")}</Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography>{description}</Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Stack direction="row" alignItems="center">
                              <Switch
                                checked={status}
                                onClick={() => {
                                  updateBlackoutDay(id, date, description, status);
                                }}
                              />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Card>
        </Box>
      </Box>
    </div>
  );
};

const Amentities = ({ values, handleChange, handleBlur, marchantType }: any) => {
  return (
    <div>
      <Box>
        <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
          <Box sx={{ marginTop: "25px" }}>
            <Box>
              <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Choose amentities available in your listing</p>
            </Box>
            <Box>
              <Grid container spacing={0} rowSpacing={1}>
                {marchantType &&
                  marchantType.map((marchanTypes: any) => (
                    <Grid item xs={6} key={marchanTypes.code}>
                      <FormGroup>
                        <FormControlLabel
                          key={`${marchanTypes.code + "-" + getUniqueKey() + "uniqueKey"}`}
                          control={
                            <Checkbox
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="amenities"
                              checked={values.amenities.includes(marchanTypes.code)}
                              value={marchanTypes.code}
                              key={`${marchanTypes.code + "-" + getUniqueKey()}`}
                            />
                          }
                          label={marchanTypes.displayValue}
                        />
                      </FormGroup>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

const Time = ({ values, handleChange, handleOperationMode, handleOperationTime }: any) => {
  return (
    <div>
      <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
        <Box>
          <Box>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Let us know the hours of operation</p>
          </Box>
          {[...Array(7)].map((item: any, index: any) => (
            <Box display={"flex"} key={index}>
              <Box marginTop={"43px"}>
                <p style={{ width: "70px" }}>{GET_DAYS[index]} </p>
              </Box>
              <Box marginTop={"32px"} marginLeft={"45px"} display={"flex"}>
                <FormControl key={index}>
                  <RadioGroup key={index} row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                    <FormControlLabel
                      key={`closed` + index}
                      control={
                        <Radio
                          onChange={(event) => {
                            handleOperationMode(event, index);
                            handleChange(event); // Corrected line
                          }}
                          value="closed"
                          name={`operationHoursList[${index}].operationalStatus`}
                          checked={values?.operationHoursList[index].operationalStatus === "closed"}
                        />
                      }
                      label="Closed"
                    />
                    <FormControlLabel
                      key={`24hr` + index}
                      control={
                        <Radio
                          onChange={(event) => {
                            handleOperationMode(event, index);
                            handleChange(event); // Corrected line
                          }}
                          value="24hr"
                          name={`operationHoursList[${index}].operationalStatus`}
                          checked={values?.operationHoursList[index].operationalStatus === "24hr"}
                        />
                      }
                      label="24 Hrs"
                    />
                    {/* <FormControlLabel
                      key={`range` + index}
                      control={
                        <Radio
                          onChange={(event) => {
                            handleOperationMode(event, index);
                            handleChange(event); // Corrected line
                          }}
                          value="range"
                          name={`operationHoursList[${index}].operationalStatus`}
                          checked={values?.operationHoursList[index].operationalStatus === 'range'}
                        />
                      }
                      label="Range"
                    /> */}
                  </RadioGroup>
                  {values?.operationHoursList[index].operationalStatus === "" && <div style={{ color: "red" }}>This field is required.</div>}
                </FormControl>
              </Box>
              {/* <Box display={'flex'}>
                <LocalizationProvider dateAdapter={AdapterDateFns} key={index}>
                  <TimePicker
                    label="From Time"
                    key={`from` + index}
                    value={
                      typeof values?.operationHoursList[index] !== 'undefined'
                        ? values?.operationHoursList[index].fromTime
                        : null
                    }
                    onChange={(newValue: any) => {
                      handleOperationTime({ target: { name: 'fromTime', value: newValue?.toString() } }, index);
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        sx={{ marginTop: 3, marginRight: 5 }}
                        onChange={handleChange} // This is correct as it invokes handleChange
                        {...params}
                        name={`operationHoursList[${index}].fromTime`}
                      />
                    )}
                    disabled={
                      typeof values?.operationHoursList[index] !== 'undefined'
                        ? values?.operationHoursList[index].operationalStatus !== 'range'
                        : false
                    }
                  />
                  <TimePicker
                    label="To time"
                    key={`to` + index}
                    value={
                      typeof values?.operationHoursList[index] !== 'undefined'
                        ? values?.operationHoursList[index].toTime
                        : null
                    }
                    onChange={(newValue: any) => {
                      handleOperationTime({ target: { name: 'toTime', value: newValue?.toString() } }, index);
                    }}
                    renderInput={(params: any) => (
                      <TextField
                        sx={{ marginTop: 3 }}
                        {...params}
                        onChange={handleChange} // This is correct as it invokes handleChange
                        name={`operationHoursList[${index}].toTime`}
                      />
                    )}
                    disabled={
                      typeof values?.operationHoursList[index] !== 'undefined'
                        ? values?.operationHoursList[index].operationalStatus !== 'range'
                        : false
                    }
                  />
                  {values?.operationHoursList[index].operationalStatus === 'range' &&
                    (values?.operationHoursList[index].fromTime === null ||
                      values?.operationHoursList[index].toTime === null) && (
                      <div style={{ color: 'red', marginTop: 40, marginLeft: 5 }}>This field is required.</div>
                    )}
                </LocalizationProvider>
              </Box> */}
            </Box>
          ))}
        </Box>
      </Box>
    </div>
  );
};

const Instructions = ({
  values,
  setFieldValue,
  handleChange,
  handleBlur,
  errors,
  contentTwo,
  setContentTwo,
  contentThree,
  setContentThree,
  contentFour,
  setContentFour,
  contentFive,
  setContentFive
}: any) => {
  return (
    <div>
      <Box>
        <Box marginBottom={10} paddingLeft={5} paddingRight={5}>
          <Box>
            <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Instructions Details</p>
          </Box>

          <Box sx={{ marginTop: "25px" }}>
            <Box>
              <Box style={{ width: "100%", marginTop: "20px" }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Cancellation Policy
                </Typography>
                <EditorToolbar toolbarId={"t3"} />
                <ReactQuill
                  theme="snow"
                  onChange={(newContent: any) => setFieldValue("CancellationPolicy", newContent)}
                  value={values.CancellationPolicy}
                  modules={modules("t3")}
                  formats={formats}
                />
                {errors.CancellationPolicy && <div style={{ color: "red" }}>{errors.CancellationPolicy}</div>}
              </Box>

              <Box style={{ width: "100%", marginTop: "20px" }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Special Instructions
                </Typography>
                <EditorToolbar toolbarId={"t4"} />
                <ReactQuill
                  theme="snow"
                  onChange={(newContent: any) => setFieldValue("Specialinstructionsforemailconfirmation", newContent)}
                  value={values.Specialinstructionsforemailconfirmation}
                  modules={modules("t4")}
                  formats={formats}
                />
                {errors.Specialinstructionsforemailconfirmation && <div style={{ color: "red" }}>{errors.Specialinstructionsforemailconfirmation}</div>}
              </Box>

              <Box style={{ width: "100%", marginTop: "20px" }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Inclusions
                </Typography>
                <EditorToolbar toolbarId={"t5"} />
                <ReactQuill
                  theme="snow"
                  onChange={(newContent: any) => setFieldValue("inclusions", newContent)}
                  value={values.inclusions}
                  modules={modules("t5")}
                  formats={formats}
                />
                {errors.inclusions && <div style={{ color: "red" }}>{errors.inclusions}</div>}
              </Box>

              <Box style={{ width: "100%", marginTop: "20px" }}>
                <Typography variant="h5" marginTop={2} gutterBottom component="div">
                  Exclusions
                </Typography>
                <EditorToolbar toolbarId={"t6"} />
                <ReactQuill
                  theme="snow"
                  onChange={(newContent: any) => setFieldValue("exclusions", newContent)}
                  value={values.exclusions}
                  modules={modules("t6")}
                  formats={formats}
                />
                {errors.exclusions && <div style={{ color: "red" }}>{errors.exclusions}</div>}
              </Box>

            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
